var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/components/InvoicePreview/PaymentDetails/UkPaymentDetails.tsx
import { Box, Divider, Flex, Text as Text2 } from "@chakra-ui/react";

// src/components/InvoicePreview/PaymentDetails/FlatAddress.tsx
import { Text } from "@chakra-ui/react";
import { formatAddress } from "@sequencehq/utils";
import { jsx } from "react/jsx-runtime";
var FlatAddress = ({ address }) => {
  const formattedAddress = formatAddress(address);
  return /* @__PURE__ */ jsx(Text, { textStyle: "invoicePaymentContent", children: formattedAddress.join(", ") });
};

// src/components/InvoicePreview/PaymentDetails/UkPaymentDetails.tsx
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var UkPaymentDetails = ({
  ukBankDetails,
  accountName,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx2(Box, { h: "8px" }),
    /* @__PURE__ */ jsx2(Divider, { borderColor: "gray.40" }),
    /* @__PURE__ */ jsx2(Box, { h: "8px" }),
    /* @__PURE__ */ jsx2(Text2, { textStyle: "infoText", children: "Via UK bank transfer" }),
    /* @__PURE__ */ jsx2(Box, { h: "9px" }),
    /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account name" }),
      /* @__PURE__ */ jsx2(Box, { w: "16px" }),
      /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentContent", children: accountName })
    ] }),
    /* @__PURE__ */ jsx2(Box, { h: "9px" }),
    includeBeneficiaryAddress && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Flex, { children: [
        /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentTitle", w: "160px", children: "Address" }),
        /* @__PURE__ */ jsx2(Box, { w: "16px" }),
        /* @__PURE__ */ jsx2(FlatAddress, { address: merchantAddress })
      ] }),
      /* @__PURE__ */ jsx2(Box, { h: "9px" })
    ] }),
    /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account number" }),
      /* @__PURE__ */ jsx2(Box, { w: "16px" }),
      /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentContent", children: ukBankDetails.accountNumber })
    ] }),
    /* @__PURE__ */ jsx2(Box, { h: "9px" }),
    /* @__PURE__ */ jsxs(Flex, { children: [
      /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentTitle", w: "160px", children: "Sort code" }),
      /* @__PURE__ */ jsx2(Box, { w: "16px" }),
      /* @__PURE__ */ jsx2(Text2, { textStyle: "invoicePaymentContent", children: ukBankDetails.sortCode })
    ] })
  ] });
};

// src/components/InvoicePreview/PaymentDetails/CanadianInternationalPaymentDetails.tsx
import { Box as Box2, Divider as Divider2, Flex as Flex2, Text as Text3 } from "@chakra-ui/react";
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var CanadianInternationalPaymentDetails = ({
  canadianInternationalDestination,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs2(Fragment2, { children: [
    /* @__PURE__ */ jsx3(Box2, { h: "8px" }),
    /* @__PURE__ */ jsx3(Divider2, { borderColor: "gray.40" }),
    /* @__PURE__ */ jsx3(Box2, { h: "8px" }),
    /* @__PURE__ */ jsx3(Flex2, { children: /* @__PURE__ */ jsx3(Text3, { textStyle: "infoText", children: "Beneficiary" }) }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Legal name" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.legalName })
    ] }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    includeBeneficiaryAddress && /* @__PURE__ */ jsxs2(Fragment2, { children: [
      /* @__PURE__ */ jsxs2(Flex2, { children: [
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Address" }),
        /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
        /* @__PURE__ */ jsx3(FlatAddress, { address: merchantAddress })
      ] }),
      /* @__PURE__ */ jsx3(Box2, { h: "9px" })
    ] }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account number" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.accountNumber })
    ] }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Transit number" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.transitNumber })
    ] }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsx3(Flex2, { children: /* @__PURE__ */ jsx3(Text3, { textStyle: "infoText", children: "Beneficiary bank" }) }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank name" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.bankName })
    ] }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank address" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(
        FlatAddress,
        {
          address: canadianInternationalDestination.bankAddress
        }
      )
    ] }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Institution number" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.institutionNumber })
    ] }),
    /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
    /* @__PURE__ */ jsxs2(Flex2, { children: [
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Swift code" }),
      /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
      /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.swiftCode })
    ] }),
    canadianInternationalDestination.intermediaryBank && /* @__PURE__ */ jsxs2(Fragment2, { children: [
      /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
      /* @__PURE__ */ jsx3(Flex2, { children: /* @__PURE__ */ jsx3(Text3, { textStyle: "infoText", children: "Intermediary bank" }) }),
      /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
      /* @__PURE__ */ jsxs2(Flex2, { children: [
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank name" }),
        /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.intermediaryBank.bankName })
      ] }),
      /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
      /* @__PURE__ */ jsxs2(Flex2, { children: [
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank address" }),
        /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
        /* @__PURE__ */ jsx3(
          FlatAddress,
          {
            address: canadianInternationalDestination.intermediaryBank.bankAddress
          }
        )
      ] }),
      /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
      /* @__PURE__ */ jsxs2(Flex2, { children: [
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Routing number" }),
        /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.intermediaryBank.routingNumber })
      ] }),
      /* @__PURE__ */ jsx3(Box2, { h: "9px" }),
      /* @__PURE__ */ jsxs2(Flex2, { children: [
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentTitle", w: "160px", children: "Swift code" }),
        /* @__PURE__ */ jsx3(Box2, { w: "16px" }),
        /* @__PURE__ */ jsx3(Text3, { textStyle: "invoicePaymentContent", children: canadianInternationalDestination.intermediaryBank.swiftCode })
      ] })
    ] })
  ] });
};

// src/components/InvoicePreview/PaymentDetails/CanadianPaymentDetails.tsx
import { Box as Box3, Divider as Divider3, Flex as Flex3, Text as Text4 } from "@chakra-ui/react";
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var CanadianPaymentDetails = ({
  canadianBankDetails,
  accountName,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs3(Fragment3, { children: [
    /* @__PURE__ */ jsx4(Box3, { h: "8px" }),
    /* @__PURE__ */ jsx4(Divider3, { borderColor: "gray.40" }),
    /* @__PURE__ */ jsx4(Box3, { h: "8px" }),
    /* @__PURE__ */ jsx4(Text4, { textStyle: "infoText", children: "Via Canadian bank transfer" }),
    /* @__PURE__ */ jsx4(Box3, { h: "9px" }),
    /* @__PURE__ */ jsxs3(Flex3, { children: [
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account name" }),
      /* @__PURE__ */ jsx4(Box3, { w: "16px" }),
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentContent", children: accountName })
    ] }),
    /* @__PURE__ */ jsx4(Box3, { h: "9px" }),
    includeBeneficiaryAddress && /* @__PURE__ */ jsxs3(Fragment3, { children: [
      /* @__PURE__ */ jsxs3(Flex3, { children: [
        /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentTitle", w: "160px", children: "Address" }),
        /* @__PURE__ */ jsx4(Box3, { w: "16px" }),
        /* @__PURE__ */ jsx4(FlatAddress, { address: merchantAddress })
      ] }),
      /* @__PURE__ */ jsx4(Box3, { h: "9px" })
    ] }),
    /* @__PURE__ */ jsxs3(Flex3, { children: [
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account number" }),
      /* @__PURE__ */ jsx4(Box3, { w: "16px" }),
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentContent", children: canadianBankDetails.accountNumber })
    ] }),
    /* @__PURE__ */ jsx4(Box3, { h: "9px" }),
    /* @__PURE__ */ jsxs3(Flex3, { children: [
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentTitle", w: "160px", children: "Transit number" }),
      /* @__PURE__ */ jsx4(Box3, { w: "16px" }),
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentContent", children: canadianBankDetails.transitNumber })
    ] }),
    /* @__PURE__ */ jsx4(Box3, { h: "9px" }),
    /* @__PURE__ */ jsxs3(Flex3, { children: [
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentTitle", w: "160px", children: "Institution number" }),
      /* @__PURE__ */ jsx4(Box3, { w: "16px" }),
      /* @__PURE__ */ jsx4(Text4, { textStyle: "invoicePaymentContent", children: canadianBankDetails.institutionNumber })
    ] })
  ] });
};

// src/components/InvoicePreview/PaymentDetails/IbanPaymentDetails.tsx
import { Box as Box4, Divider as Divider4, Flex as Flex4, Text as Text5 } from "@chakra-ui/react";
import { Fragment as Fragment4, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var IbanPaymentDetails = ({
  iban,
  accountName,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs4(Fragment4, { children: [
    /* @__PURE__ */ jsx5(Box4, { h: "8px" }),
    /* @__PURE__ */ jsx5(Divider4, { borderColor: "gray.40" }),
    /* @__PURE__ */ jsx5(Box4, { h: "8px" }),
    /* @__PURE__ */ jsx5(Text5, { textStyle: "infoText", children: "Via bank transfer" }),
    /* @__PURE__ */ jsx5(Box4, { h: "9px" }),
    /* @__PURE__ */ jsxs4(Flex4, { children: [
      /* @__PURE__ */ jsx5(Text5, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account name" }),
      /* @__PURE__ */ jsx5(Box4, { w: "16px" }),
      /* @__PURE__ */ jsx5(Text5, { textStyle: "invoicePaymentContent", children: accountName })
    ] }),
    /* @__PURE__ */ jsx5(Box4, { h: "9px" }),
    includeBeneficiaryAddress && /* @__PURE__ */ jsxs4(Fragment4, { children: [
      /* @__PURE__ */ jsxs4(Flex4, { children: [
        /* @__PURE__ */ jsx5(Text5, { textStyle: "invoicePaymentTitle", w: "160px", children: "Address" }),
        /* @__PURE__ */ jsx5(Box4, { w: "16px" }),
        /* @__PURE__ */ jsx5(FlatAddress, { address: merchantAddress })
      ] }),
      /* @__PURE__ */ jsx5(Box4, { h: "9px" })
    ] }),
    /* @__PURE__ */ jsxs4(Flex4, { children: [
      /* @__PURE__ */ jsx5(Text5, { textStyle: "invoicePaymentTitle", w: "160px", children: "IBAN" }),
      /* @__PURE__ */ jsx5(Box4, { w: "16px" }),
      /* @__PURE__ */ jsx5(Text5, { textStyle: "invoicePaymentContent", children: iban })
    ] })
  ] });
};

// src/components/InvoicePreview/PaymentDetails/UsAchPaymentDetails.tsx
import { Box as Box5, Divider as Divider5, Flex as Flex5, Text as Text6 } from "@chakra-ui/react";
import { Fragment as Fragment5, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var UsAchPaymentDetails = ({
  achDetails,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs5(Fragment5, { children: [
    /* @__PURE__ */ jsx6(Box5, { h: "8px" }),
    /* @__PURE__ */ jsx6(Divider5, { borderColor: "gray.40" }),
    /* @__PURE__ */ jsx6(Box5, { h: "8px" }),
    /* @__PURE__ */ jsx6(Text6, { textStyle: "infoText", children: "Via ACH" }),
    /* @__PURE__ */ jsx6(Box5, { h: "9px" }),
    /* @__PURE__ */ jsxs5(Flex5, { children: [
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account name" }),
      /* @__PURE__ */ jsx6(Box5, { w: "16px" }),
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentContent", children: achDetails.accountName })
    ] }),
    /* @__PURE__ */ jsx6(Box5, { h: "9px" }),
    includeBeneficiaryAddress && /* @__PURE__ */ jsxs5(Fragment5, { children: [
      /* @__PURE__ */ jsxs5(Flex5, { children: [
        /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentTitle", w: "160px", children: "Address" }),
        /* @__PURE__ */ jsx6(Box5, { w: "16px" }),
        /* @__PURE__ */ jsx6(FlatAddress, { address: merchantAddress })
      ] }),
      /* @__PURE__ */ jsx6(Box5, { h: "9px" })
    ] }),
    /* @__PURE__ */ jsxs5(Flex5, { children: [
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account number" }),
      /* @__PURE__ */ jsx6(Box5, { w: "16px" }),
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentContent", children: achDetails.accountNumber })
    ] }),
    /* @__PURE__ */ jsx6(Box5, { h: "9px" }),
    /* @__PURE__ */ jsxs5(Flex5, { children: [
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank name" }),
      /* @__PURE__ */ jsx6(Box5, { w: "16px" }),
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentContent", children: achDetails.bankName })
    ] }),
    /* @__PURE__ */ jsx6(Box5, { h: "9px" }),
    /* @__PURE__ */ jsxs5(Flex5, { children: [
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank routing number" }),
      /* @__PURE__ */ jsx6(Box5, { w: "16px" }),
      /* @__PURE__ */ jsx6(Text6, { textStyle: "invoicePaymentContent", children: achDetails.bankRoutingNumber })
    ] })
  ] });
};

// src/components/InvoicePreview/PaymentDetails/UsWirePaymentDetails.tsx
import { Box as Box6, Divider as Divider6, Flex as Flex6, Text as Text7 } from "@chakra-ui/react";
import { Fragment as Fragment6, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var UsWirePaymentDetails = ({
  wireDetails,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs6(Fragment6, { children: [
    /* @__PURE__ */ jsx7(Box6, { h: "8px" }),
    /* @__PURE__ */ jsx7(Divider6, { borderColor: "gray.40" }),
    /* @__PURE__ */ jsx7(Box6, { h: "8px" }),
    /* @__PURE__ */ jsx7(Text7, { textStyle: "infoText", children: "Via Wire" }),
    /* @__PURE__ */ jsx7(Box6, { h: "9px" }),
    /* @__PURE__ */ jsxs6(Flex6, { children: [
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account name" }),
      /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentContent", children: wireDetails.accountName })
    ] }),
    /* @__PURE__ */ jsx7(Box6, { h: "9px" }),
    includeBeneficiaryAddress && /* @__PURE__ */ jsxs6(Fragment6, { children: [
      /* @__PURE__ */ jsxs6(Flex6, { children: [
        /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Address" }),
        /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
        /* @__PURE__ */ jsx7(FlatAddress, { address: merchantAddress })
      ] }),
      /* @__PURE__ */ jsx7(Box6, { h: "9px" })
    ] }),
    /* @__PURE__ */ jsxs6(Flex6, { children: [
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Account number" }),
      /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentContent", children: wireDetails.accountNumber })
    ] }),
    /* @__PURE__ */ jsx7(Box6, { h: "9px" }),
    /* @__PURE__ */ jsxs6(Flex6, { children: [
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank name" }),
      /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentContent", children: wireDetails.bankName })
    ] }),
    /* @__PURE__ */ jsx7(Box6, { h: "9px" }),
    /* @__PURE__ */ jsxs6(Flex6, { children: [
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank routing number" }),
      /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentContent", children: wireDetails.bankRoutingNumber })
    ] }),
    /* @__PURE__ */ jsx7(Box6, { h: "9px" }),
    /* @__PURE__ */ jsxs6(Flex6, { children: [
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Swift code" }),
      /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentContent", textAlign: "right", children: wireDetails.swiftCode })
    ] }),
    /* @__PURE__ */ jsx7(Box6, { h: "9px" }),
    /* @__PURE__ */ jsxs6(Flex6, { children: [
      /* @__PURE__ */ jsx7(Text7, { textStyle: "invoicePaymentTitle", w: "160px", children: "Bank address" }),
      /* @__PURE__ */ jsx7(Box6, { w: "16px" }),
      /* @__PURE__ */ jsx7(FlatAddress, { address: wireDetails.bankAddress })
    ] })
  ] });
};

// src/components/ReactPdfInvoice/ReactPdfInvoice.tsx
import { useRef, useState } from "react";
import { Document, View as View25 } from "@react-pdf/renderer";
import { toMoney as toMoney6 } from "@sequencehq/core-models";
import { localDateWithFormat as localDateWithFormat5 } from "@sequencehq/formatters";

// src/components/ReactPdfInvoice/PageLayouts/PageLayoutSecondary/PageLayoutSecondary.tsx
import { View } from "@react-pdf/renderer";

// src/components/ReactPdfInvoice/Styles.tsx
import {
  GreyGrey100,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  IndigoIndigo50,
  Lato12Bold,
  Lato12Regular,
  Lato16Bold,
  Lato24Bold
} from "@sequencehq/design-tokens";
import { StyleSheet } from "@react-pdf/renderer";

// src/components/ReactPdfInvoice/utils.ts
var tokenize = (input) => {
  return input.match(/\w+|\W+/g)?.map((s) => s.replace(/ /g, "\xA0"));
};
var fixDesignTokenForPdf = (props) => {
  const fontSizeNum = Number(props.fontSize.replace("px", ""));
  const lineHeightNum = Number(props.lineHeight.replace("px", ""));
  return {
    ...props,
    fontSize: fontSizeNum,
    lineHeight: lineHeightNum / fontSizeNum
  };
};
var chunkUnbreakableStrings = (token, maxChars) => {
  const numChunks = Math.ceil(token.length / maxChars);
  return Array.from(
    { length: numChunks },
    (_58, i) => token.slice(i * maxChars, i * maxChars + maxChars)
  );
};

// src/components/ReactPdfInvoice/Styles.tsx
var styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: 89,
    paddingTop: 32
  },
  wrapper: {
    paddingLeft: 24,
    paddingRight: 24
  },
  pageAccent: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 4
  },
  pageFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    padding: 24
  },
  pageSeparator: {
    height: 1,
    backgroundColor: GreyGrey30
  },
  watermark: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  watermarkText: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 144,
    textTransform: "uppercase",
    opacity: 0.3,
    transform: "rotate(-45deg)"
  },
  /**
   * Primary page sections
   */
  sectionHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16
  },
  sectionSummary: {
    display: "flex",
    flexDirection: "row",
    gap: 16,
    marginBottom: 24
  },
  sectionInvoicePaymentOverview: {
    marginBottom: 24,
    gap: 8
  },
  /**
   * Lato 24 Bold
   */
  lato24BoldGreyGrey100: {
    ...fixDesignTokenForPdf(Lato24Bold),
    color: GreyGrey100
  },
  lato24BoldGreyGrey80: {
    ...fixDesignTokenForPdf(Lato24Bold),
    color: GreyGrey80
  },
  /**
   * Lato 16 Bold
   */
  lato16BoldGreyGrey100: {
    ...fixDesignTokenForPdf(Lato16Bold),
    color: GreyGrey100
  },
  lato16BoldGreyGrey80: {
    ...fixDesignTokenForPdf(Lato16Bold),
    color: GreyGrey80
  },
  /**
   * Lato 12 Regular
   */
  lato12RegularGreyGrey100: {
    ...fixDesignTokenForPdf(Lato12Regular),
    color: GreyGrey100
  },
  lato12RegularGreyGrey80: {
    ...fixDesignTokenForPdf(Lato12Regular),
    color: GreyGrey80
  },
  lato12RegularGreyGrey60: {
    ...fixDesignTokenForPdf(Lato12Regular),
    color: GreyGrey60
  },
  /**
   * Lato 12 Bold
   */
  lato12BoldGreyGrey100: {
    ...fixDesignTokenForPdf(Lato12Bold),
    color: GreyGrey100
  },
  lato12BoldGreyGrey80: {
    ...fixDesignTokenForPdf(Lato12Bold),
    color: GreyGrey80
  },
  lato12BoldLink: {
    ...fixDesignTokenForPdf(Lato12Bold),
    color: IndigoIndigo50,
    textDecoration: "none"
  }
});
var Styles_default = styles;

// src/components/ReactPdfInvoice/PageLayouts/PageLayoutSecondary/PageLayoutSecondary.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var { pageSeparator } = Styles_default;
var PageLayoutSecondary = ({
  accent,
  header,
  footerString,
  refTotalsPage,
  watermarks,
  children,
  type,
  hiddenPageNumberText
}) => /* @__PURE__ */ jsxs7(
  PageLayout,
  {
    accent,
    header,
    footerString,
    refTotalsPage,
    watermarks,
    style: { gap: 24 },
    type,
    children: [
      /* @__PURE__ */ jsx8(View, { style: pageSeparator, fixed: true }),
      /* @__PURE__ */ jsxs7(
        View,
        {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end"
          },
          children: [
            hiddenPageNumberText && /* @__PURE__ */ jsx8(View, { style: { display: "none" }, children: hiddenPageNumberText }),
            /* @__PURE__ */ jsx8(View, { style: { width: 312, gap: 16 }, children })
          ]
        }
      )
    ]
  }
);

// src/components/ReactPdfInvoice/PageLayouts/PageLayoutSecondary/PageLayoutSecondaryGroup.tsx
import { View as View2, Text as Text8 } from "@react-pdf/renderer";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var { lato12BoldGreyGrey80 } = Styles_default;
var PageLayoutSecondaryGroup = ({
  title,
  children,
  gap = 16
}) => /* @__PURE__ */ jsxs8(View2, { style: { gap }, children: [
  /* @__PURE__ */ jsx9(Text8, { style: lato12BoldGreyGrey80, children: title }),
  /* @__PURE__ */ jsx9(View2, { style: { gap: 24 }, children })
] });

// src/components/ReactPdfInvoice/PageLayouts/PageLayoutSecondary/PageLayoutSecondaryHeader.tsx
import { View as View3, Text as Text9 } from "@react-pdf/renderer";
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var { lato12BoldGreyGrey80: lato12BoldGreyGrey802 } = Styles_default;
var PageLayoutSecondaryHeader = ({ title, children }) => /* @__PURE__ */ jsxs9(
  View3,
  {
    style: { display: "flex", flexDirection: "row", gap: 16, minHeight: 32 },
    fixed: true,
    children: [
      /* @__PURE__ */ jsx10(View3, { style: { flex: 1 }, children: /* @__PURE__ */ jsx10(Text9, { style: lato12BoldGreyGrey802, children: title }) }),
      /* @__PURE__ */ jsx10(View3, { style: { width: 312 }, children })
    ]
  }
);

// src/components/ReactPdfInvoice/PageLayouts/PageLayoutSecondary/PageLayoutSecondaryLine.tsx
import { View as View4, Text as Text10 } from "@react-pdf/renderer";
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var { lato12RegularGreyGrey60, lato12RegularGreyGrey80 } = Styles_default;
var PageLayoutSecondaryLine = ({ title, content }) => /* @__PURE__ */ jsxs10(View4, { style: { display: "flex", flexDirection: "row", gap: 16 }, wrap: false, children: [
  /* @__PURE__ */ jsx11(View4, { style: { width: 124 }, children: /* @__PURE__ */ jsx11(Text10, { style: lato12RegularGreyGrey60, children: title }) }),
  /* @__PURE__ */ jsx11(View4, { style: { flex: 1 }, children: /* @__PURE__ */ jsx11(Text10, { style: lato12RegularGreyGrey80, children: content }) })
] });

// src/components/ReactPdfInvoice/PageLayouts/PageLayoutSecondary/PageLayoutSecondarySection.tsx
import { View as View5 } from "@react-pdf/renderer";
import { jsx as jsx12 } from "react/jsx-runtime";
var PageLayoutSecondarySection = ({
  children
}) => /* @__PURE__ */ jsx12(View5, { style: { gap: 8 }, children });

// src/components/ReactPdfInvoice/PageLayouts/PageLayout.tsx
import { Page, View as View10 } from "@react-pdf/renderer";

// src/components/ReactPdfInvoice/constants.ts
var PAGE_SIZE = "A4";
var PAGE_DPI = 72;
var DEFAULT_COLUMNS = {
  description: {
    value: "Description",
    paddingLeft: 0,
    textAlign: "left"
  },
  quantity: {
    value: "Qty",
    width: 52
  },
  rate: {
    value: "Rate",
    width: 88
  },
  taxRate: {
    value: "Tax",
    width: 46
  },
  netTotal: {
    value: "Price",
    width: 90,
    paddingRight: 0
  }
};

// src/components/ReactPdfInvoice/HeaderFooter/Header.tsx
import { View as View6, Text as Text11 } from "@react-pdf/renderer";
import { match } from "ts-pattern";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var { lato24BoldGreyGrey100, lato16BoldGreyGrey100, sectionHeader } = Styles_default;
var Header = ({
  merchantDetails,
  type,
  isRenderedInBrowser
}) => {
  const headerText = match(type).with("invoice", () => "Invoice").with("creditNote", () => "Credit note").exhaustive();
  return /* @__PURE__ */ jsxs11(View6, { style: sectionHeader, children: [
    /* @__PURE__ */ jsx13(Text11, { style: lato24BoldGreyGrey100, children: headerText }),
    merchantDetails.logoUrl ? /* @__PURE__ */ jsx13(
      MerchantLogo,
      {
        logoUrl: merchantDetails.logoUrl,
        isRenderedInBrowser
      }
    ) : /* @__PURE__ */ jsx13(Text11, { style: lato16BoldGreyGrey100, children: merchantDetails.legalCompanyName })
  ] });
};

// src/components/ReactPdfInvoice/HeaderFooter/MerchantLogo.tsx
import { View as View7, Image } from "@react-pdf/renderer";
import { jsx as jsx14 } from "react/jsx-runtime";
var MerchantLogo = ({
  logoUrl,
  isRenderedInBrowser
}) => {
  const imgSrc = isRenderedInBrowser ? {
    uri: logoUrl,
    method: "GET",
    headers: { "Cache-Control": "no-cache" },
    body: ""
  } : logoUrl;
  return /* @__PURE__ */ jsx14(View7, { children: /* @__PURE__ */ jsx14(Image, { src: imgSrc, style: { height: 28 } }) });
};

// src/components/ReactPdfInvoice/HeaderFooter/PageAccent.tsx
import { View as View8 } from "@react-pdf/renderer";
import { jsx as jsx15 } from "react/jsx-runtime";
var { pageAccent } = Styles_default;
var PageAccent = ({
  merchantDetails
}) => {
  const backgroundColor = merchantDetails.primaryColour ?? "transparent";
  return /* @__PURE__ */ jsx15(View8, { style: { ...pageAccent, backgroundColor }, fixed: true });
};

// src/components/ReactPdfInvoice/HeaderFooter/PageFooter.tsx
import { View as View9, Text as Text12 } from "@react-pdf/renderer";
import { Fragment as Fragment7, jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var { pageFooter, pageSeparator: pageSeparator2, lato12RegularGreyGrey80: lato12RegularGreyGrey802 } = Styles_default;
var PageFooter = ({
  text,
  refTotalsPage,
  type
}) => /* @__PURE__ */ jsx16(View9, { style: pageFooter, fixed: true, children: /* @__PURE__ */ jsx16(
  View9,
  {
    style: { display: "flex", gap: 24, justifyContent: "flex-end" },
    render: ({ pageNumber }) => /* @__PURE__ */ jsxs12(Fragment7, { children: [
      pageNumber === refTotalsPage.current && /* @__PURE__ */ jsx16(PoweredBySequence, { type }),
      /* @__PURE__ */ jsx16(View9, { style: pageSeparator2 }),
      /* @__PURE__ */ jsxs12(
        View9,
        {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%"
          },
          children: [
            /* @__PURE__ */ jsx16(Text12, { style: lato12RegularGreyGrey802, children: text }),
            /* @__PURE__ */ jsx16(
              Text12,
              {
                style: lato12RegularGreyGrey802,
                render: ({ totalPages }) => `Page ${pageNumber} of ${totalPages}`
              }
            )
          ]
        }
      )
    ] })
  }
) });

// src/components/ReactPdfInvoice/HeaderFooter/PoweredBySequence.tsx
import { Text as Text13, Link } from "@react-pdf/renderer";

// src/components/ReactPdfInvoice/HeaderFooter/Wordmark.tsx
import { Path, Svg } from "@react-pdf/renderer";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var Wordmark = () => /* @__PURE__ */ jsxs13(
  Svg,
  {
    width: "65",
    height: "15",
    viewBox: "0 0 65 15",
    fill: "none",
    style: { width: 65, height: 15 },
    children: [
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M5.36707 11.4172C6.63874 11.4172 7.64425 11.1422 8.36881 10.5923C9.09336 10.0424 9.46304 9.28989 9.46304 8.33478C9.46304 7.53886 9.19687 6.90212 8.66455 6.42457C8.13222 5.96149 7.27458 5.59971 6.07684 5.33922L5.16006 5.15109C4.27285 4.97744 3.68137 4.7459 3.35606 4.48541C3.03075 4.25387 2.86809 3.89209 2.86809 3.41454C2.86809 2.95145 3.04554 2.60414 3.41521 2.34366C3.77009 2.09765 4.30242 1.9674 4.9974 1.9674C5.88461 1.9674 6.52045 2.12659 6.9197 2.44496C7.31894 2.76333 7.54074 3.24088 7.59989 3.90656H9.1673C9.13772 2.89357 8.78284 2.09765 8.08786 1.51879C7.39287 0.93994 6.35779 0.650513 4.98262 0.650513C3.82924 0.650513 2.92724 0.910997 2.26183 1.41749C1.58164 1.92399 1.25632 2.60414 1.25632 3.44348C1.25632 4.29729 1.52249 4.96297 2.08439 5.44052C2.6315 5.93255 3.44478 6.27986 4.53901 6.48246L5.44101 6.67058C6.32822 6.87318 6.94927 7.09025 7.30415 7.33626C7.64425 7.58228 7.82169 7.92959 7.82169 8.3782C7.82169 8.94258 7.59989 9.37672 7.18586 9.66615C6.77183 9.95557 6.16557 10.1003 5.39665 10.1003C3.50393 10.1003 2.55757 9.33331 2.528 7.78487H0.945801C0.945801 8.97152 1.34505 9.88322 2.11396 10.491C2.88288 11.1133 3.97711 11.4172 5.36707 11.4172Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M17.4455 7.50992C17.4455 6.35221 17.1202 5.41158 16.4843 4.65907C15.8337 3.92103 14.9465 3.54478 13.8227 3.54478C12.7433 3.54478 11.8708 3.90656 11.2054 4.61565C10.5252 5.33922 10.1999 6.27986 10.1999 7.45203C10.1999 8.63868 10.5252 9.57932 11.2054 10.2884C11.8708 11.012 12.758 11.3593 13.8523 11.3593C14.7247 11.3593 15.464 11.1422 16.0555 10.7081C16.647 10.2739 17.061 9.66615 17.268 8.89917H15.7746C15.4788 9.7385 14.843 10.1437 13.8818 10.1437C13.2312 10.1437 12.7285 9.97005 12.3588 9.59379C11.9743 9.21754 11.7525 8.66763 11.6934 7.92959H17.4455V7.50992ZM13.8227 4.76037C14.4142 4.76037 14.8873 4.9485 15.257 5.32475C15.6267 5.701 15.8485 6.17856 15.9224 6.78635H11.7082C11.7969 6.13514 12.0187 5.62865 12.3884 5.28134C12.758 4.93402 13.2312 4.76037 13.8227 4.76037Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M24.1135 4.81825C23.5368 3.97892 22.694 3.54478 21.585 3.54478C20.5203 3.54478 19.6627 3.90656 19.0416 4.60118C18.4058 5.31028 18.0952 6.26539 18.0952 7.45203C18.0952 8.65315 18.4058 9.60826 19.0416 10.3029C19.6627 11.012 20.5203 11.3593 21.585 11.3593C22.6496 11.3593 23.4777 10.9686 24.0544 10.1726V14.022H25.533V3.71843H24.1135V4.81825ZM20.2393 9.43461C19.8253 8.98599 19.6331 8.34926 19.6331 7.50992C19.6331 6.67058 19.8253 6.0049 20.2393 5.51288C20.6386 5.03532 21.1857 4.78931 21.8659 4.78931C22.5609 4.78931 23.108 5.02085 23.5072 5.48393C23.8917 5.96149 24.0987 6.6127 24.0987 7.45203C24.0987 8.30584 23.8917 8.95705 23.5072 9.40566C23.108 9.88322 22.5609 10.1148 21.8659 10.1148C21.1857 10.1148 20.6386 9.89769 20.2393 9.43461Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M31.9069 7.92959C31.9069 8.60974 31.7147 9.14518 31.3451 9.52143C30.9754 9.89769 30.517 10.0858 29.9847 10.0858C28.9052 10.0858 28.3729 9.56485 28.3729 8.52291V3.71843H26.8942V8.72551C26.8942 9.56485 27.1308 10.2016 27.604 10.6647C28.0772 11.1278 28.7278 11.3593 29.5706 11.3593C30.5761 11.3593 31.3746 10.9396 31.9661 10.0713V11.1856H33.3856V3.71843H31.9069V7.92959Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M41.6369 7.50992C41.6369 6.35221 41.3116 5.41158 40.6758 4.65907C40.0251 3.92103 39.1379 3.54478 38.0141 3.54478C36.9347 3.54478 36.0623 3.90656 35.3968 4.61565C34.7166 5.33922 34.3913 6.27986 34.3913 7.45203C34.3913 8.63868 34.7166 9.57932 35.3968 10.2884C36.0623 11.012 36.9495 11.3593 38.0437 11.3593C38.9161 11.3593 39.6555 11.1422 40.2469 10.7081C40.8384 10.2739 41.2524 9.66615 41.4595 8.89917H39.966C39.6702 9.7385 39.0344 10.1437 38.0733 10.1437C37.4226 10.1437 36.9199 9.97005 36.5502 9.59379C36.1658 9.21754 35.944 8.66763 35.8848 7.92959H41.6369V7.50992ZM38.0141 4.76037C38.6056 4.76037 39.0788 4.9485 39.4484 5.32475C39.8181 5.701 40.0399 6.17856 40.1139 6.78635H35.8996C35.9883 6.13514 36.2101 5.62865 36.5798 5.28134C36.9495 4.93402 37.4226 4.76037 38.0141 4.76037Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M46.4566 3.54478C45.4363 3.54478 44.6378 3.97892 44.0611 4.83273V3.71843H42.6416V11.1856H44.1202V6.97448C44.1202 6.27986 44.3125 5.74442 44.7117 5.36816C45.0962 5.00638 45.5398 4.81825 46.0425 4.81825C47.1072 4.81825 47.6543 5.33922 47.6543 6.38116V11.1856H49.133V6.17856C49.133 5.33922 48.8964 4.70248 48.4232 4.2394C47.95 3.77632 47.2846 3.54478 46.4566 3.54478Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M53.7763 11.3593C54.693 11.3593 55.462 11.1133 56.083 10.5923C56.7041 10.0858 57.0737 9.39119 57.192 8.52291H55.6838C55.595 9.04388 55.3732 9.43461 55.0331 9.69509C54.6783 9.97004 54.2642 10.1003 53.7763 10.1003C53.1256 10.1003 52.6229 9.88322 52.2384 9.42013C51.854 8.95705 51.6765 8.30584 51.6765 7.45203C51.6765 6.6127 51.854 5.96149 52.2384 5.49841C52.6229 5.03532 53.1256 4.80378 53.7763 4.80378C54.2494 4.80378 54.6635 4.93402 55.0036 5.19451C55.3437 5.45499 55.5655 5.83125 55.669 6.32327H57.1772C57.0589 5.48393 56.6893 4.80378 56.083 4.29729C55.4767 3.80526 54.7078 3.54478 53.7763 3.54478C52.682 3.54478 51.7948 3.90656 51.1442 4.60118C50.464 5.32475 50.1387 6.26539 50.1387 7.45203C50.1387 8.63868 50.464 9.57932 51.1442 10.2884C51.8096 11.012 52.682 11.3593 53.7763 11.3593Z",
          fill: "#241F25"
        }
      ),
      /* @__PURE__ */ jsx17(
        Path,
        {
          d: "M64.9475 7.50992C64.9475 6.35221 64.6222 5.41158 63.9863 4.65907C63.3357 3.92103 62.4485 3.54478 61.3247 3.54478C60.2452 3.54478 59.3728 3.90656 58.7074 4.61565C58.0272 5.33922 57.7019 6.27986 57.7019 7.45203C57.7019 8.63868 58.0272 9.57932 58.7074 10.2884C59.3728 11.012 60.26 11.3593 61.3543 11.3593C62.2267 11.3593 62.966 11.1422 63.5575 10.7081C64.149 10.2739 64.563 9.66615 64.77 8.89917H63.2765C62.9808 9.7385 62.345 10.1437 61.3838 10.1437C60.7332 10.1437 60.2304 9.97005 59.8608 9.59379C59.4763 9.21754 59.2545 8.66763 59.1954 7.92959H64.9475V7.50992ZM61.3247 4.76037C61.9162 4.76037 62.3893 4.9485 62.759 5.32475C63.1287 5.701 63.3505 6.17856 63.4244 6.78635H59.2102C59.2989 6.13514 59.5207 5.62865 59.8904 5.28134C60.26 4.93402 60.7332 4.76037 61.3247 4.76037Z",
          fill: "#241F25"
        }
      )
    ]
  }
);

// src/components/ReactPdfInvoice/HeaderFooter/PoweredBySequence.tsx
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var { lato12RegularGreyGrey80: lato12RegularGreyGrey803 } = Styles_default;
var PoweredBySequence = ({ type }) => {
  const href = (() => {
    const ROOT_URL = "https://sequencehq.com";
    if (type === "invoice") {
      return `${ROOT_URL}?utm_campaign=pdf-invoice`;
    } else {
      return `${ROOT_URL}?utm_campaign=pdf-credit-note`;
    }
  })();
  return /* @__PURE__ */ jsxs14(
    Link,
    {
      href,
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        textDecoration: "none"
      },
      children: [
        /* @__PURE__ */ jsx18(Text13, { style: { ...lato12RegularGreyGrey803, marginRight: 4 }, children: "Powered by" }),
        /* @__PURE__ */ jsx18(Wordmark, {})
      ]
    }
  );
};

// src/components/ReactPdfInvoice/PageLayouts/PageLayout.tsx
import { jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var { page, wrapper } = Styles_default;
var PageLayout = ({
  accent,
  header,
  footerString,
  refTotalsPage,
  watermarks,
  children,
  style = {},
  type
}) => /* @__PURE__ */ jsxs15(Page, { size: PAGE_SIZE, dpi: PAGE_DPI, style: page, wrap: true, children: [
  accent,
  /* @__PURE__ */ jsxs15(View10, { style: { ...wrapper, ...style }, children: [
    header,
    children
  ] }),
  /* @__PURE__ */ jsx19(PageFooter, { refTotalsPage, text: footerString, type }),
  watermarks
] });

// src/components/ReactPdfInvoice/helpers.ts
import { formatAddress as formatAddress2 } from "@sequencehq/utils";
var getMerchantDetailsToUse = ({
  invoice,
  merchantDetails
}) => {
  return ["IN_PROGRESS", "DRAFT"].includes(invoice.status) ? merchantDetails : invoice.merchantDetails;
};
var hasPaymentsDetailsPage = (merchantDetails) => {
  return [
    !!merchantDetails.ukAccountDetails,
    !!merchantDetails.caBankAccountDetails,
    !!merchantDetails.canadianInternationalDestination,
    !!merchantDetails.iban,
    !!merchantDetails.usAchDetails,
    !!merchantDetails.usWireDetails,
    !!merchantDetails.australianDestination
  ].includes(true);
};
var flattenAddress = (address) => formatAddress2(address).join("\n");

// src/components/ReactPdfInvoice/strings.ts
import { match as match2 } from "ts-pattern";
import {
  percentageFromDecimal,
  toMoney
} from "@sequencehq/core-models";
import { localDateWithFormat, toPercentage } from "@sequencehq/formatters";
import { formatDateRange } from "@sequencehq/utils/dates";
var renderInvoiceLabel = (key) => {
  return match2(key).with("invoiceNumber", () => "Invoice number").with("accountingDate", () => "Invoice date").with("purchaseOrderNumber", () => "Purchase order").with("reference", () => "Reference").with("issueDate", () => "Issue date").with("dueDate", () => "Due date").with("memo", () => "Memo").with("billingPeriod", () => "Billing period").exhaustive();
};
var renderCreditNoteLabel = (key) => {
  return match2(key).with("creditNoteNumber", () => "Credit note number").with("invoiceNumber", () => "Related invoice").with("issueDate", () => "Date of issue").with("purchaseOrderNumber", () => "Purchase order").with("billingPeriod", () => "Billing period").exhaustive();
};
var renderInvoiceNumber = (invoiceNumber) => {
  return invoiceNumber || "Pending";
};
var renderIssueDate = (issueDate) => issueDate ? localDateWithFormat(issueDate, "d MMMM yyyy") : "Pending issuing";
var renderDueDate = ({
  dueDate,
  defaultDueDateDays
}) => {
  return dueDate ? localDateWithFormat(dueDate, "d MMMM yyyy") : defaultDueDateDays ? `${defaultDueDateDays} days` : "Pending issuing";
};
var renderBillingPeriod = (billingPeriod) => {
  return formatDateRange({
    from: new Date(billingPeriod.start),
    to: new Date(billingPeriod.endInclusive),
    separator: "-"
  });
};
var renderQuantity = ({
  lineItem,
  currency
}) => {
  return lineItem.rateDisplay === "PERCENTAGE" ? toMoney({ currency, value: lineItem.quantity }) : lineItem.quantity;
};
var renderRate = ({
  lineItem,
  currency
}) => {
  return lineItem.rateDisplay === "PERCENTAGE" ? toPercentage(percentageFromDecimal(lineItem.rate)) : toMoney({ currency, value: lineItem.rate }, "", 10);
};
var renderTaxRate = ({
  lineItem
}) => {
  return toPercentage(percentageFromDecimal(lineItem.taxRate));
};
var renderNetTotal = ({
  lineItem,
  currency
}) => {
  return toMoney({ currency, value: lineItem.netTotal });
};

// src/components/ReactPdfInvoice/Details/Address.tsx
import { View as View11, Text as Text14 } from "@react-pdf/renderer";
import { formatAddress as formatAddress3 } from "@sequencehq/utils";
import { jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var { lato12BoldGreyGrey80: lato12BoldGreyGrey803, lato12RegularGreyGrey80: lato12RegularGreyGrey804 } = Styles_default;
var Address = ({
  style,
  heading,
  name,
  address,
  phoneNumber,
  email,
  taxId
}) => {
  const addressLines = formatAddress3(address);
  return /* @__PURE__ */ jsxs16(View11, { style, children: [
    /* @__PURE__ */ jsx20(Text14, { style: lato12BoldGreyGrey803, children: heading }),
    name && /* @__PURE__ */ jsx20(Text14, { style: lato12RegularGreyGrey804, children: name }),
    addressLines.map((line, key) => /* @__PURE__ */ jsx20(Text14, { style: lato12RegularGreyGrey804, children: line }, key)),
    phoneNumber && /* @__PURE__ */ jsx20(Text14, { style: lato12RegularGreyGrey804, children: phoneNumber }),
    email && /* @__PURE__ */ jsx20(Text14, { style: lato12RegularGreyGrey804, children: email }),
    taxId && /* @__PURE__ */ jsxs16(Text14, { style: lato12RegularGreyGrey804, children: [
      "Tax ID: ",
      taxId
    ] })
  ] });
};

// src/components/ReactPdfInvoice/Details/PaymentOverview.tsx
import { Fragment as Fragment8 } from "react";
import { Link as Link2, Text as Text15, View as View12 } from "@react-pdf/renderer";
import { toMoney as toMoney2 } from "@sequencehq/core-models";
import { localDateWithFormat as localDateWithFormat2 } from "@sequencehq/formatters";

// src/components/ReactPdfInvoice/guards.ts
import {
  currencies
} from "@sequencehq/core-models";
var isInvoiceModel = (obj) => {
  return "dueDate" in obj || "billingPeriod" in obj || "accountingDate" in obj;
};
var assertIsCreditNoteModel = (obj) => true;
var isValidCurrencyString = (value) => {
  return currencies.includes(value);
};

// src/components/ReactPdfInvoice/Details/PaymentOverview.tsx
import { Fragment as Fragment9, jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var {
  sectionInvoicePaymentOverview,
  lato16BoldGreyGrey80,
  lato12BoldLink,
  lato12RegularGreyGrey80: lato12RegularGreyGrey805
} = Styles_default;
var PaymentOverview = ({
  type,
  invoiceOrCreditNote,
  urlRootCustomerPortal,
  urlRootApi,
  paymentDetailsPage,
  isCustomerPortalEnabled,
  externalPaymentDetailsPageNumber
}) => {
  const { currency, grossTotal } = invoiceOrCreditNote;
  const shouldDisplayPaymentLink = "renderSettings" in invoiceOrCreditNote && invoiceOrCreditNote.renderSettings?.paymentLinkDisplay === "SHOW_PAYMENT_LINK";
  const isInvoice = type === "invoice" && isInvoiceModel(invoiceOrCreditNote);
  const hasLinkPaymentOption = isInvoiceModel(invoiceOrCreditNote) ? Boolean(invoiceOrCreditNote.paymentOptions?.includes("LINK")) : false;
  const linkPayOnline = (() => {
    if (!isInvoice || !urlRootApi || invoiceOrCreditNote.status !== "SENT" || !shouldDisplayPaymentLink) {
      return void 0;
    }
    if (!hasLinkPaymentOption) {
      return void 0;
    }
    return `${urlRootApi}/payments/invoice/${invoiceOrCreditNote.id}`;
  })();
  const linkViewOnline = (() => {
    if (isInvoice && invoiceOrCreditNote.status === "SENT" && isCustomerPortalEnabled && urlRootCustomerPortal) {
      return `${urlRootCustomerPortal}/customers/${invoiceOrCreditNote.customerId}/invoices/${invoiceOrCreditNote.id}`;
    }
  })();
  const hasLinkPayOnline = Boolean(linkPayOnline);
  const hasLinkViewOnline = isCustomerPortalEnabled && Boolean(linkViewOnline);
  const hasPaymentDetails = type === "invoice" && (paymentDetailsPage && paymentDetailsPage > 0 || typeof externalPaymentDetailsPageNumber !== "undefined");
  const overviewItems = [
    hasLinkPayOnline ? /* @__PURE__ */ jsx21(Link2, { src: linkPayOnline, style: lato12BoldLink, children: "Pay online" }) : null,
    hasLinkViewOnline ? /* @__PURE__ */ jsx21(Link2, { src: linkViewOnline, style: lato12BoldLink, children: "View invoice online" }) : null,
    hasPaymentDetails ? /* @__PURE__ */ jsxs17(Text15, { style: lato12RegularGreyGrey805, children: [
      "See payment details on page",
      " ",
      externalPaymentDetailsPageNumber || paymentDetailsPage
    ] }) : null
  ].filter(Boolean);
  return /* @__PURE__ */ jsxs17(View12, { style: sectionInvoicePaymentOverview, children: [
    /* @__PURE__ */ jsxs17(Text15, { style: lato16BoldGreyGrey80, children: [
      toMoney2({ currency, value: grossTotal }),
      isInvoiceModel(invoiceOrCreditNote) && /* @__PURE__ */ jsxs17(Fragment9, { children: [
        " due ",
        localDateWithFormat2(invoiceOrCreditNote.dueDate, "d MMMM yyyy")
      ] })
    ] }),
    /* @__PURE__ */ jsxs17(
      View12,
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 4
        },
        children: [
          /* @__PURE__ */ jsx21(
            View12,
            {
              style: {
                display: "flex",
                flexDirection: "row",
                gap: 4,
                textDecoration: "none"
              },
              children: overviewItems.map((item, index) => /* @__PURE__ */ jsxs17(Fragment8, { children: [
                item,
                index !== overviewItems.length - 1 && /* @__PURE__ */ jsx21(Text15, { style: lato12RegularGreyGrey805, children: "-" })
              ] }, index))
            }
          ),
          isInvoice && hasLinkPaymentOption ? /* @__PURE__ */ jsx21(Text15, { style: lato12RegularGreyGrey805, children: "You may be charged automatically for this invoice." }) : null
        ]
      }
    )
  ] });
};

// src/components/ReactPdfInvoice/Details/Summary.tsx
import { View as View13, Text as Text16 } from "@react-pdf/renderer";
import { localDateWithFormat as localDateWithFormat3 } from "@sequencehq/formatters";
import { jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var { sectionSummary, lato12RegularGreyGrey80: lato12RegularGreyGrey806, lato12BoldGreyGrey80: lato12BoldGreyGrey804 } = Styles_default;
var Summary = ({
  type,
  invoiceOrCreditNote,
  merchantDetails,
  defaultDueDateDays
}) => {
  const {
    invoiceNumber,
    purchaseOrderNumber,
    issueDate,
    memo,
    customerLegalCompanyName,
    customerBillingAddress,
    customerTaxId
  } = invoiceOrCreditNote;
  const isReverseChargeInvoice = isInvoiceModel(invoiceOrCreditNote) && invoiceOrCreditNote.customerTaxStatus === "REVERSE_CHARGED";
  return /* @__PURE__ */ jsxs18(View13, { style: sectionSummary, children: [
    /* @__PURE__ */ jsxs18(View13, { style: { width: 312, gap: 16 }, children: [
      type === "invoice" && /* @__PURE__ */ jsxs18(View13, { children: [
        /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("invoiceNumber"),
            value: invoiceNumber || "Pending"
          }
        ),
        isInvoiceModel(invoiceOrCreditNote) && invoiceOrCreditNote.billingPeriod && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("billingPeriod"),
            value: renderBillingPeriod(invoiceOrCreditNote.billingPeriod)
          }
        ),
        isInvoiceModel(invoiceOrCreditNote) && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("accountingDate"),
            value: localDateWithFormat3(
              invoiceOrCreditNote.accountingDate,
              "d MMMM yyyy"
            )
          }
        ),
        purchaseOrderNumber && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("purchaseOrderNumber"),
            value: purchaseOrderNumber
          }
        ),
        isInvoiceModel(invoiceOrCreditNote) && invoiceOrCreditNote.reference && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("reference"),
            value: invoiceOrCreditNote.reference
          }
        ),
        /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("issueDate"),
            value: renderIssueDate(issueDate)
          }
        ),
        isInvoiceModel(invoiceOrCreditNote) && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderInvoiceLabel("dueDate"),
            value: renderDueDate({
              dueDate: invoiceOrCreditNote.dueDate,
              defaultDueDateDays
            })
          }
        ),
        isReverseChargeInvoice && /* @__PURE__ */ jsx22(Text16, { style: lato12BoldGreyGrey804, children: "Reverse charge applies" })
      ] }),
      type === "creditNote" && /* @__PURE__ */ jsxs18(View13, { children: [
        assertIsCreditNoteModel(invoiceOrCreditNote) && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderCreditNoteLabel("creditNoteNumber"),
            value: invoiceOrCreditNote.creditNoteNumber || "Pending"
          }
        ),
        purchaseOrderNumber && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderCreditNoteLabel("purchaseOrderNumber"),
            value: purchaseOrderNumber
          }
        ),
        invoiceNumber && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderCreditNoteLabel("invoiceNumber"),
            value: invoiceNumber
          }
        ),
        assertIsCreditNoteModel(invoiceOrCreditNote) && invoiceOrCreditNote.billingPeriodStart && invoiceOrCreditNote.billingPeriodEnd && /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderCreditNoteLabel("billingPeriod"),
            value: renderBillingPeriod({
              start: invoiceOrCreditNote.billingPeriodStart,
              endInclusive: invoiceOrCreditNote.billingPeriodEnd
            })
          }
        ),
        /* @__PURE__ */ jsx22(
          SummaryTextPair,
          {
            title: renderCreditNoteLabel("issueDate"),
            value: renderIssueDate(issueDate)
          }
        )
      ] }),
      /* @__PURE__ */ jsx22(
        Address,
        {
          heading: type === "creditNote" ? "Credited to" : "Billed to",
          name: customerLegalCompanyName,
          address: customerBillingAddress,
          taxId: customerTaxId,
          customerCountry: customerBillingAddress.country
        }
      ),
      memo && /* @__PURE__ */ jsx22(Text16, { style: lato12RegularGreyGrey806, children: memo })
    ] }),
    merchantDetails && /* @__PURE__ */ jsx22(
      Address,
      {
        style: { flex: 1, textAlign: "right" },
        heading: merchantDetails.legalCompanyName,
        address: merchantDetails.address,
        phoneNumber: merchantDetails.phoneNumber,
        email: merchantDetails.email,
        taxId: merchantDetails.taxId,
        customerCountry: customerBillingAddress.country
      }
    )
  ] });
};

// src/components/ReactPdfInvoice/Details/SummaryTextPair.tsx
import { View as View14, Text as Text17 } from "@react-pdf/renderer";
import { jsx as jsx23, jsxs as jsxs19 } from "react/jsx-runtime";
var { lato12RegularGreyGrey80: lato12RegularGreyGrey807, lato12BoldGreyGrey80: lato12BoldGreyGrey805 } = Styles_default;
var SummaryTextPair = ({
  title: titleProp,
  value
}) => {
  const title = `${titleProp}:`;
  return /* @__PURE__ */ jsxs19(View14, { style: { display: "flex", flexDirection: "row", flexWrap: "wrap" }, children: [
    tokenize(title)?.map((seg, i) => /* @__PURE__ */ jsx23(Text17, { style: lato12BoldGreyGrey805, children: seg }, i)),
    /* @__PURE__ */ jsx23(Text17, { style: lato12BoldGreyGrey805, children: " " }),
    tokenize(value)?.map((seg, i) => /* @__PURE__ */ jsx23(Text17, { style: lato12RegularGreyGrey807, children: seg }, i))
  ] });
};

// src/components/ReactPdfInvoice/Details/Totals.tsx
import { View as View16, Text as Text19 } from "@react-pdf/renderer";
import { match as match3 } from "ts-pattern";

// src/components/ReactPdfInvoice/Details/TotalTable.tsx
import { View as View15, Text as Text18 } from "@react-pdf/renderer";
import { toMoney as toMoney3 } from "@sequencehq/core-models";
import { jsx as jsx24, jsxs as jsxs20 } from "react/jsx-runtime";
var { lato12BoldGreyGrey100 } = Styles_default;
var TotalTable = ({
  title,
  currency,
  netTotal,
  totalTax,
  grossTotal,
  finalTotalLabel
}) => {
  return /* @__PURE__ */ jsxs20(View15, { style: { minWidth: 244, marginBottom: "16px" }, children: [
    title && /* @__PURE__ */ jsx24(Text18, { style: lato12BoldGreyGrey100, children: title }),
    /* @__PURE__ */ jsx24(
      TotalsLine,
      {
        title: "Subtotal",
        value: toMoney3({ currency, value: netTotal })
      }
    ),
    /* @__PURE__ */ jsx24(TotalsLine, { title: "Tax", value: toMoney3({ currency, value: totalTax }) }),
    /* @__PURE__ */ jsx24(
      TotalsLine,
      {
        title: finalTotalLabel,
        value: toMoney3({ currency, value: grossTotal }),
        textStyle: lato12BoldGreyGrey100,
        borderBottom: 0
      }
    )
  ] });
};

// src/components/ReactPdfInvoice/Details/Totals.tsx
import { jsx as jsx25, jsxs as jsxs21 } from "react/jsx-runtime";
var Totals = ({
  type,
  invoiceOrCreditNote,
  refTotalsPage
}) => {
  const { currency, netTotal, grossTotal, totalTax } = invoiceOrCreditNote;
  const finalTotalLabel = match3(type).with("invoice", () => "Amount due").with("creditNote", () => "Credit total").exhaustive();
  return /* @__PURE__ */ jsxs21(View16, { style: { display: "flex", alignItems: "flex-end" }, wrap: false, children: [
    /* @__PURE__ */ jsx25(View16, { style: { minWidth: 244 }, children: /* @__PURE__ */ jsx25(
      TotalTable,
      {
        currency,
        netTotal,
        totalTax,
        grossTotal,
        finalTotalLabel
      }
    ) }),
    /* @__PURE__ */ jsx25(
      Text19,
      {
        render: ({ pageNumber }) => {
          refTotalsPage.current = pageNumber;
          return "";
        },
        style: { display: "none" }
      }
    )
  ] });
};

// src/components/ReactPdfInvoice/Details/TotalsLine.tsx
import { View as View17, Text as Text20 } from "@react-pdf/renderer";
import { GreyGrey30 as GreyGrey302 } from "@sequencehq/design-tokens";
import { jsx as jsx26, jsxs as jsxs22 } from "react/jsx-runtime";
var { lato12RegularGreyGrey100 } = Styles_default;
var baseStyle = {
  display: "flex",
  flexDirection: "row",
  borderBottom: 1,
  borderBottomStyle: "solid",
  borderBottomColor: GreyGrey302,
  paddingTop: 7,
  paddingBottom: 7,
  justifyContent: "space-between",
  gap: 16
};
var TotalsLine = ({
  title,
  value,
  textStyle = lato12RegularGreyGrey100,
  borderBottom
}) => /* @__PURE__ */ jsxs22(
  View17,
  {
    style: {
      ...baseStyle,
      ...typeof borderBottom !== "undefined" ? { borderBottom } : {}
    },
    children: [
      /* @__PURE__ */ jsx26(Text20, { style: { ...textStyle }, children: title }),
      /* @__PURE__ */ jsx26(Text20, { style: { ...textStyle, textAlign: "right" }, children: value })
    ]
  }
);

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsCanadianBankTransfer.tsx
import { jsx as jsx27, jsxs as jsxs23 } from "react/jsx-runtime";
var PaymentDetailsCanadianBankTransfer = ({
  canadianBankDetails,
  accountName,
  merchantAddress,
  includeBeneficiaryAddress
}) => /* @__PURE__ */ jsx27(PageLayoutSecondaryGroup, { title: "Via Canadian bank transfer", children: /* @__PURE__ */ jsxs23(PageLayoutSecondarySection, { children: [
  /* @__PURE__ */ jsx27(PageLayoutSecondaryLine, { title: "Account name", content: accountName }),
  includeBeneficiaryAddress && /* @__PURE__ */ jsx27(
    PageLayoutSecondaryLine,
    {
      title: "Address",
      content: flattenAddress(merchantAddress)
    }
  ),
  /* @__PURE__ */ jsx27(
    PageLayoutSecondaryLine,
    {
      title: "Account number",
      content: canadianBankDetails.accountNumber
    }
  ),
  /* @__PURE__ */ jsx27(
    PageLayoutSecondaryLine,
    {
      title: "Transit number",
      content: canadianBankDetails.transitNumber
    }
  ),
  /* @__PURE__ */ jsx27(
    PageLayoutSecondaryLine,
    {
      title: "Institution number",
      content: canadianBankDetails.institutionNumber
    }
  )
] }) });

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsCanadianInternationalBankTransfer.tsx
import { Text as Text21, View as View18 } from "@react-pdf/renderer";
import { jsx as jsx28, jsxs as jsxs24 } from "react/jsx-runtime";
var { lato12BoldGreyGrey80: lato12BoldGreyGrey806 } = Styles_default;
var PaymentDetailsCanadianInternationalBankTransfer = ({
  canadianInternationalDestination,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs24(View18, { style: { gap: 12 }, children: [
    /* @__PURE__ */ jsx28(Text21, { style: lato12BoldGreyGrey806, children: "Via Canadian international bank transfer" }),
    /* @__PURE__ */ jsx28(PageLayoutSecondaryGroup, { title: "Beneficiary", gap: 12, children: /* @__PURE__ */ jsxs24(PageLayoutSecondarySection, { children: [
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Legal name",
          content: canadianInternationalDestination.legalName
        }
      ),
      includeBeneficiaryAddress && /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Address",
          content: flattenAddress(merchantAddress)
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Account number",
          content: canadianInternationalDestination.accountNumber
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Transit number",
          content: canadianInternationalDestination.transitNumber
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx28(PageLayoutSecondaryGroup, { title: "Beneficiary bank", gap: 12, children: /* @__PURE__ */ jsxs24(PageLayoutSecondarySection, { children: [
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Bank name",
          content: canadianInternationalDestination.bankName
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Bank address",
          content: flattenAddress(
            canadianInternationalDestination.bankAddress
          )
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Insitution number",
          content: canadianInternationalDestination.institutionNumber
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Swift code",
          content: canadianInternationalDestination.swiftCode
        }
      )
    ] }) }),
    canadianInternationalDestination.intermediaryBank && /* @__PURE__ */ jsx28(PageLayoutSecondaryGroup, { title: "Intermediary bank", gap: 12, children: /* @__PURE__ */ jsxs24(PageLayoutSecondarySection, { children: [
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Bank name",
          content: canadianInternationalDestination.intermediaryBank.bankName
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Bank address",
          content: flattenAddress(
            canadianInternationalDestination.intermediaryBank.bankAddress
          )
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Routing number",
          content: canadianInternationalDestination.intermediaryBank.routingNumber
        }
      ),
      /* @__PURE__ */ jsx28(
        PageLayoutSecondaryLine,
        {
          title: "Swift code",
          content: canadianInternationalDestination.intermediaryBank.swiftCode
        }
      )
    ] }) })
  ] });
};

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsIban.tsx
import { jsx as jsx29, jsxs as jsxs25 } from "react/jsx-runtime";
var PaymentDetailsIban = ({
  iban,
  accountName,
  merchantAddress,
  includeBeneficiaryAddress
}) => /* @__PURE__ */ jsx29(PageLayoutSecondaryGroup, { title: "Via bank transfer", children: /* @__PURE__ */ jsxs25(PageLayoutSecondarySection, { children: [
  /* @__PURE__ */ jsx29(PageLayoutSecondaryLine, { title: "Account name", content: accountName }),
  includeBeneficiaryAddress && /* @__PURE__ */ jsx29(
    PageLayoutSecondaryLine,
    {
      title: "Address",
      content: flattenAddress(merchantAddress)
    }
  ),
  /* @__PURE__ */ jsx29(PageLayoutSecondaryLine, { title: "IBAN", content: iban })
] }) });

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsUkBankTransfer.tsx
import { jsx as jsx30, jsxs as jsxs26 } from "react/jsx-runtime";
var PaymentDetailsUkBankTransfer = ({
  ukBankDetails,
  accountName,
  merchantAddress,
  includeBeneficiaryAddress
}) => /* @__PURE__ */ jsx30(PageLayoutSecondaryGroup, { title: "Via UK bank transfer", children: /* @__PURE__ */ jsxs26(PageLayoutSecondarySection, { children: [
  /* @__PURE__ */ jsx30(PageLayoutSecondaryLine, { title: "Account name", content: accountName }),
  includeBeneficiaryAddress && /* @__PURE__ */ jsx30(
    PageLayoutSecondaryLine,
    {
      title: "Address",
      content: flattenAddress(merchantAddress)
    }
  ),
  /* @__PURE__ */ jsx30(
    PageLayoutSecondaryLine,
    {
      title: "Account number",
      content: ukBankDetails.accountNumber
    }
  ),
  /* @__PURE__ */ jsx30(
    PageLayoutSecondaryLine,
    {
      title: "Sort code",
      content: ukBankDetails.sortCode
    }
  )
] }) });

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsUsAch.tsx
import { jsx as jsx31, jsxs as jsxs27 } from "react/jsx-runtime";
var PaymentDetailsUsAch = ({
  achDetails,
  merchantAddress,
  includeBeneficiaryAddress
}) => /* @__PURE__ */ jsx31(PageLayoutSecondaryGroup, { title: "Via ACH", children: /* @__PURE__ */ jsxs27(PageLayoutSecondarySection, { children: [
  /* @__PURE__ */ jsx31(
    PageLayoutSecondaryLine,
    {
      title: "Account name",
      content: achDetails.accountName
    }
  ),
  includeBeneficiaryAddress && /* @__PURE__ */ jsx31(
    PageLayoutSecondaryLine,
    {
      title: "Address",
      content: flattenAddress(merchantAddress)
    }
  ),
  /* @__PURE__ */ jsx31(
    PageLayoutSecondaryLine,
    {
      title: "Account number",
      content: achDetails.accountNumber
    }
  ),
  /* @__PURE__ */ jsx31(
    PageLayoutSecondaryLine,
    {
      title: "Bank name",
      content: achDetails.bankName
    }
  ),
  /* @__PURE__ */ jsx31(
    PageLayoutSecondaryLine,
    {
      title: "Bank routing number",
      content: achDetails.bankRoutingNumber
    }
  )
] }) });

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsUsWire.tsx
import { jsx as jsx32, jsxs as jsxs28 } from "react/jsx-runtime";
var PaymentDetailsUsWire = ({
  wireDetails,
  merchantAddress,
  includeBeneficiaryAddress
}) => /* @__PURE__ */ jsx32(PageLayoutSecondaryGroup, { title: "Via wire", children: /* @__PURE__ */ jsxs28(PageLayoutSecondarySection, { children: [
  /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Account name",
      content: wireDetails.accountName
    }
  ),
  includeBeneficiaryAddress && /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Address",
      content: flattenAddress(merchantAddress)
    }
  ),
  /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Account number",
      content: wireDetails.accountNumber
    }
  ),
  /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Bank name",
      content: wireDetails.bankName
    }
  ),
  /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Bank routing number",
      content: wireDetails.bankRoutingNumber
    }
  ),
  /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Swift code",
      content: wireDetails.swiftCode
    }
  ),
  /* @__PURE__ */ jsx32(
    PageLayoutSecondaryLine,
    {
      title: "Bank address",
      content: flattenAddress(wireDetails.bankAddress)
    }
  )
] }) });

// src/components/ReactPdfInvoice/PageTypes/PageCreditBalance.tsx
import { Text as Text22 } from "@react-pdf/renderer";
import { toMoney as toMoney4 } from "@sequencehq/core-models";
import { localDateWithFormat as localDateWithFormat4 } from "@sequencehq/formatters";
import { jsx as jsx33, jsxs as jsxs29 } from "react/jsx-runtime";
var { lato12RegularGreyGrey80: lato12RegularGreyGrey808, lato12BoldGreyGrey80: lato12BoldGreyGrey807 } = Styles_default;
var PageCreditBalance = ({
  pageAccent: pageAccent2,
  footerString,
  refTotalsPage,
  watermarks,
  creditBalance
}) => {
  const { name, balance, grants } = creditBalance;
  return /* @__PURE__ */ jsx33(
    PageLayoutSecondary,
    {
      accent: pageAccent2,
      header: /* @__PURE__ */ jsxs29(PageLayoutSecondaryHeader, { title: "Credit Balance", children: [
        creditBalance.type === "CASH" && isValidCurrencyString(name) && /* @__PURE__ */ jsx33(Text22, { style: lato12BoldGreyGrey807, children: toMoney4({ currency: name, value: balance }) }),
        creditBalance.type === "USAGE" && /* @__PURE__ */ jsxs29(Text22, { style: lato12BoldGreyGrey807, children: [
          balance,
          " credits"
        ] }),
        /* @__PURE__ */ jsx33(Text22, { style: lato12RegularGreyGrey808, children: name })
      ] }),
      footerString,
      refTotalsPage,
      watermarks,
      type: "invoice",
      children: /* @__PURE__ */ jsx33(PageLayoutSecondaryGroup, { title: "Credit Grants", children: grants.map((grant) => {
        return /* @__PURE__ */ jsxs29(PageLayoutSecondarySection, { children: [
          /* @__PURE__ */ jsx33(PageLayoutSecondaryLine, { title: "Name", content: grant.name }),
          grant.type === "CASH" && isValidCurrencyString(name) && /* @__PURE__ */ jsx33(
            PageLayoutSecondaryLine,
            {
              title: "Balance",
              content: `${toMoney4({
                currency: name,
                value: grant.currentBalance
              })}/${toMoney4({
                currency: name,
                value: grant.originalAmount
              })}`
            }
          ),
          grant.type === "USAGE" && /* @__PURE__ */ jsx33(
            PageLayoutSecondaryLine,
            {
              title: "Balance",
              content: `${grant.currentBalance}/${grant.originalAmount} credits`
            }
          ),
          grant.expiryDate && /* @__PURE__ */ jsx33(
            PageLayoutSecondaryLine,
            {
              title: "Expires on",
              content: localDateWithFormat4(grant.expiryDate, "d MMMM yyyy")
            }
          )
        ] }, grant.id);
      }) })
    }
  );
};

// src/components/ReactPdfInvoice/PageTypes/PagePaymentDetails.tsx
import { Text as Text24 } from "@react-pdf/renderer";

// src/components/ReactPdfInvoice/Details/PaymentDetails/PaymentDetailsAustralianBankTransfer.tsx
import { Text as Text23, View as View19 } from "@react-pdf/renderer";
import { jsx as jsx34, jsxs as jsxs30 } from "react/jsx-runtime";
var { lato12BoldGreyGrey80: lato12BoldGreyGrey808 } = Styles_default;
var PaymentDetailsAustralianBankTransfer = ({
  australianDestination,
  merchantAddress,
  includeBeneficiaryAddress
}) => {
  return /* @__PURE__ */ jsxs30(View19, { style: { gap: 12 }, children: [
    /* @__PURE__ */ jsx34(Text23, { style: lato12BoldGreyGrey808, children: "Via Australian bank transfer" }),
    /* @__PURE__ */ jsx34(PageLayoutSecondaryGroup, { title: "Beneficiary", gap: 12, children: /* @__PURE__ */ jsxs30(PageLayoutSecondarySection, { children: [
      /* @__PURE__ */ jsx34(
        PageLayoutSecondaryLine,
        {
          title: "Legal name",
          content: australianDestination.legalName
        }
      ),
      includeBeneficiaryAddress && /* @__PURE__ */ jsx34(
        PageLayoutSecondaryLine,
        {
          title: "Address",
          content: flattenAddress(merchantAddress)
        }
      ),
      /* @__PURE__ */ jsx34(
        PageLayoutSecondaryLine,
        {
          title: "Account number",
          content: australianDestination.accountNumber
        }
      ),
      /* @__PURE__ */ jsx34(
        PageLayoutSecondaryLine,
        {
          title: "BSB",
          content: australianDestination.bsb
        }
      ),
      /* @__PURE__ */ jsx34(
        PageLayoutSecondaryLine,
        {
          title: "Swift code",
          content: australianDestination.swiftCode
        }
      )
    ] }) })
  ] });
};

// src/components/ReactPdfInvoice/PageTypes/PagePaymentDetails.tsx
import { jsx as jsx35, jsxs as jsxs31 } from "react/jsx-runtime";
var { lato12RegularGreyGrey80: lato12RegularGreyGrey809 } = Styles_default;
var PagePaymentDetails = ({
  pageAccent: pageAccent2,
  footerString,
  refTotalsPage,
  invoice,
  merchantDetails,
  watermarks,
  setPaymentDetailsPage,
  setExternalPaymentDetailsPageNumber
}) => /* @__PURE__ */ jsxs31(
  PageLayoutSecondary,
  {
    accent: pageAccent2,
    header: /* @__PURE__ */ jsx35(PageLayoutSecondaryHeader, { title: `${invoice.currency} Payment`, children: /* @__PURE__ */ jsxs31(Text24, { style: lato12RegularGreyGrey809, children: [
      "Use these payment details below to transfer funds to",
      " ",
      merchantDetails.legalCompanyName,
      "\u2019s bank account."
    ] }) }),
    footerString,
    refTotalsPage,
    watermarks,
    type: "invoice",
    hiddenPageNumberText: /* @__PURE__ */ jsx35(
      Text24,
      {
        render: ({ pageNumber }) => {
          setPaymentDetailsPage(pageNumber);
          if (setExternalPaymentDetailsPageNumber) {
            setExternalPaymentDetailsPageNumber(pageNumber);
          }
          return "";
        },
        style: { display: "none" }
      }
    ),
    children: [
      merchantDetails.ukAccountDetails && /* @__PURE__ */ jsx35(
        PaymentDetailsUkBankTransfer,
        {
          ukBankDetails: merchantDetails.ukAccountDetails,
          accountName: merchantDetails.legalCompanyName,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      ),
      merchantDetails.iban && /* @__PURE__ */ jsx35(
        PaymentDetailsIban,
        {
          iban: merchantDetails.iban,
          accountName: merchantDetails.legalCompanyName,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      ),
      merchantDetails.usAchDetails && /* @__PURE__ */ jsx35(
        PaymentDetailsUsAch,
        {
          achDetails: merchantDetails.usAchDetails,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      ),
      merchantDetails.usWireDetails && /* @__PURE__ */ jsx35(
        PaymentDetailsUsWire,
        {
          wireDetails: merchantDetails.usWireDetails,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      ),
      merchantDetails.caBankAccountDetails && /* @__PURE__ */ jsx35(
        PaymentDetailsCanadianBankTransfer,
        {
          canadianBankDetails: merchantDetails.caBankAccountDetails,
          accountName: merchantDetails.legalCompanyName,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      ),
      merchantDetails.canadianInternationalDestination && /* @__PURE__ */ jsx35(
        PaymentDetailsCanadianInternationalBankTransfer,
        {
          canadianInternationalDestination: merchantDetails.canadianInternationalDestination,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      ),
      merchantDetails.australianDestination && /* @__PURE__ */ jsx35(
        PaymentDetailsAustralianBankTransfer,
        {
          australianDestination: merchantDetails.australianDestination,
          merchantAddress: merchantDetails.address,
          includeBeneficiaryAddress: merchantDetails.includeBeneficiaryAddressInPaymentDetails
        }
      )
    ]
  }
);

// src/components/ReactPdfInvoice/PageTypes/PageCurrencyConversions.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var PageCurrencyConversions = ({
  pageAccent: pageAccent2,
  footerString,
  refTotalsPage,
  watermarks,
  currencyConversions
}) => {
  return /* @__PURE__ */ jsx36(
    PageLayoutSecondary,
    {
      accent: pageAccent2,
      footerString,
      refTotalsPage,
      watermarks,
      type: "invoice",
      children: /* @__PURE__ */ jsx36(PageLayoutSecondaryGroup, { title: "Currency Conversions", children: currencyConversions.map((conversion) => /* @__PURE__ */ jsx36(
        TotalTable,
        {
          title: `Currency conversion: ${conversion.currency}`,
          currency: conversion.currency,
          netTotal: conversion.netTotal,
          totalTax: conversion.totalTax,
          grossTotal: conversion.grossTotal,
          finalTotalLabel: "Total"
        },
        conversion.id
      )) })
    }
  );
};

// src/components/ReactPdfInvoice/LineItems/LineItemRow.tsx
import { GreyGrey30 as GreyGrey303 } from "@sequencehq/design-tokens";

// src/components/ReactPdfInvoice/Table/Table.tsx
import { View as View20, Text as Text25 } from "@react-pdf/renderer";
import { jsx as jsx37, jsxs as jsxs32 } from "react/jsx-runtime";
var { lato12BoldGreyGrey100: lato12BoldGreyGrey1002, lato12RegularGreyGrey60: lato12RegularGreyGrey602 } = Styles_default;
var Table = ({
  primaryText,
  secondaryText,
  children,
  style
}) => {
  const hasHeader = Boolean(primaryText) || Boolean(secondaryText);
  return /* @__PURE__ */ jsxs32(View20, { style: style?.container, children: [
    hasHeader && /* @__PURE__ */ jsxs32(
      View20,
      {
        style: {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          ...style?.header ?? {}
        },
        children: [
          primaryText && tokenize(primaryText)?.map((seg, i) => /* @__PURE__ */ jsx37(
            Text25,
            {
              style: { ...lato12BoldGreyGrey1002, minWidth: "1" },
              hyphenationCallback: (text) => chunkUnbreakableStrings(text, 78),
              children: seg
            },
            i
          )),
          secondaryText && /* @__PURE__ */ jsx37(Text25, { style: lato12BoldGreyGrey1002, children: "   " }),
          secondaryText && tokenize(secondaryText)?.map((seg, i) => /* @__PURE__ */ jsx37(
            Text25,
            {
              style: lato12RegularGreyGrey602,
              hyphenationCallback: (text) => chunkUnbreakableStrings(text, 78),
              children: seg
            },
            i
          ))
        ]
      }
    ),
    children
  ] });
};

// src/components/ReactPdfInvoice/Table/TableCell.tsx
import { View as View21, Text as Text26 } from "@react-pdf/renderer";
import { Fragment as Fragment10, jsx as jsx38, jsxs as jsxs33 } from "react/jsx-runtime";
var { lato12RegularGreyGrey100: lato12RegularGreyGrey1002, lato12RegularGreyGrey60: lato12RegularGreyGrey603 } = Styles_default;
var TableCell = ({
  wrap = false,
  value,
  secondaryValue,
  width,
  textAlign = "right",
  paddingLeft = 8,
  paddingRight = 8,
  paddingTop = 11,
  paddingBottom = 8,
  fontStyle = lato12RegularGreyGrey1002,
  secondaryFontStyle = lato12RegularGreyGrey603
}) => {
  const finalWidth = typeof width !== "undefined" ? width + paddingLeft + paddingRight : void 0;
  return /* @__PURE__ */ jsxs33(
    View21,
    {
      style: {
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        width: finalWidth,
        ...typeof width === "undefined" ? { flex: 1 } : {}
      },
      children: [
        wrap ? /* @__PURE__ */ jsx38(
          View21,
          {
            style: { display: "flex", flexDirection: "row", flexWrap: "wrap" },
            children: tokenize(value)?.map((seg, i) => /* @__PURE__ */ jsx38(
              Text26,
              {
                style: {
                  ...fontStyle,
                  minWidth: "1",
                  maxWidth: "100%"
                },
                hyphenationCallback: (text) => chunkUnbreakableStrings(text, 32),
                children: seg
              },
              i
            ))
          }
        ) : /* @__PURE__ */ jsx38(Text26, { style: { ...fontStyle, textAlign, width: "100%" }, children: value }),
        secondaryValue && /* @__PURE__ */ jsx38(Fragment10, { children: wrap ? /* @__PURE__ */ jsx38(
          View21,
          {
            style: {
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap"
            },
            children: tokenize(secondaryValue)?.map((seg, i) => /* @__PURE__ */ jsx38(
              Text26,
              {
                style: {
                  ...secondaryFontStyle,
                  minWidth: "1",
                  maxWidth: "100%"
                },
                hyphenationCallback: (text) => chunkUnbreakableStrings(text, 32),
                children: seg
              },
              i
            ))
          }
        ) : /* @__PURE__ */ jsx38(Text26, { style: secondaryFontStyle, children: secondaryValue }) })
      ]
    }
  );
};

// src/components/ReactPdfInvoice/Table/TableRow.tsx
import { View as View22 } from "@react-pdf/renderer";
import { jsx as jsx39 } from "react/jsx-runtime";
var TableRow = ({ children, borderBottom }) => /* @__PURE__ */ jsx39(
  View22,
  {
    style: {
      display: "flex",
      flexDirection: "row",
      ...typeof borderBottom !== "undefined" ? {
        borderBottom: 1,
        borderBottomColor: borderBottom,
        borderBottomStyle: "solid"
      } : {}
    },
    wrap: false,
    children
  }
);

// src/components/ReactPdfInvoice/Lato12Regular.json
var Lato12Regular_exports = {};
__export(Lato12Regular_exports, {
  "0": () => _,
  "100": () => _00,
  "101": () => _01,
  "102": () => _022,
  "103": () => _032,
  "104": () => _042,
  "105": () => _052,
  "106": () => _062,
  "107": () => _07,
  "108": () => _08,
  "109": () => _09,
  "110": () => _10,
  "111": () => _11,
  "112": () => _122,
  "113": () => _132,
  "114": () => _142,
  "115": () => _152,
  "116": () => _162,
  "117": () => _17,
  "118": () => _18,
  "119": () => _19,
  "120": () => _20,
  "121": () => _21,
  "122": () => _222,
  "123": () => _232,
  "124": () => _242,
  "125": () => _252,
  "126": () => _262,
  "13": () => _3,
  "160": () => _60,
  "161": () => _61,
  "162": () => _622,
  "163": () => _632,
  "164": () => _642,
  "165": () => _652,
  "166": () => _662,
  "167": () => _672,
  "168": () => _68,
  "169": () => _69,
  "170": () => _70,
  "171": () => _71,
  "172": () => _722,
  "173": () => _732,
  "174": () => _742,
  "175": () => _752,
  "176": () => _762,
  "177": () => _772,
  "178": () => _78,
  "179": () => _79,
  "180": () => _80,
  "181": () => _81,
  "182": () => _822,
  "183": () => _832,
  "184": () => _842,
  "185": () => _852,
  "186": () => _862,
  "187": () => _872,
  "188": () => _88,
  "189": () => _89,
  "190": () => _90,
  "191": () => _91,
  "192": () => _922,
  "193": () => _932,
  "194": () => _942,
  "195": () => _952,
  "196": () => _962,
  "197": () => _972,
  "198": () => _98,
  "199": () => _99,
  "200": () => _002,
  "201": () => _012,
  "202": () => _023,
  "203": () => _033,
  "204": () => _043,
  "205": () => _053,
  "206": () => _063,
  "207": () => _072,
  "208": () => _082,
  "209": () => _092,
  "210": () => _102,
  "211": () => _112,
  "212": () => _123,
  "213": () => _133,
  "214": () => _143,
  "215": () => _153,
  "216": () => _163,
  "217": () => _172,
  "218": () => _182,
  "219": () => _192,
  "220": () => _202,
  "221": () => _212,
  "222": () => _223,
  "223": () => _233,
  "224": () => _243,
  "225": () => _253,
  "226": () => _263,
  "227": () => _272,
  "228": () => _28,
  "229": () => _29,
  "230": () => _30,
  "231": () => _31,
  "232": () => _322,
  "233": () => _332,
  "234": () => _342,
  "235": () => _352,
  "236": () => _362,
  "237": () => _372,
  "238": () => _382,
  "239": () => _39,
  "240": () => _40,
  "241": () => _41,
  "242": () => _422,
  "243": () => _432,
  "244": () => _442,
  "245": () => _452,
  "246": () => _462,
  "247": () => _472,
  "248": () => _48,
  "249": () => _49,
  "250": () => _50,
  "251": () => _51,
  "252": () => _522,
  "253": () => _532,
  "254": () => _542,
  "255": () => _552,
  "260": () => _602,
  "261": () => _612,
  "262": () => _623,
  "263": () => _633,
  "280": () => _802,
  "281": () => _812,
  "305": () => _054,
  "32": () => _2,
  "321": () => _213,
  "322": () => _224,
  "323": () => _234,
  "324": () => _244,
  "33": () => _32,
  "338": () => _383,
  "339": () => _392,
  "34": () => _4,
  "346": () => _463,
  "347": () => _473,
  "35": () => _5,
  "352": () => _523,
  "353": () => _533,
  "36": () => _6,
  "37": () => _7,
  "376": () => _763,
  "377": () => _773,
  "378": () => _782,
  "379": () => _792,
  "38": () => _8,
  "380": () => _803,
  "381": () => _813,
  "382": () => _823,
  "39": () => _9,
  "40": () => _0,
  "402": () => _024,
  "41": () => _1,
  "42": () => _22,
  "43": () => _33,
  "44": () => _42,
  "45": () => _52,
  "46": () => _62,
  "47": () => _72,
  "48": () => _82,
  "49": () => _92,
  "50": () => _02,
  "51": () => _12,
  "52": () => _23,
  "53": () => _34,
  "54": () => _43,
  "55": () => _53,
  "56": () => _63,
  "57": () => _73,
  "58": () => _83,
  "59": () => _93,
  "60": () => _03,
  "61": () => _13,
  "62": () => _24,
  "63": () => _35,
  "64": () => _44,
  "64257": () => _4257,
  "64258": () => _4258,
  "65": () => _54,
  "66": () => _64,
  "67": () => _74,
  "68": () => _84,
  "69": () => _94,
  "70": () => _04,
  "71": () => _14,
  "710": () => _103,
  "711": () => _113,
  "713": () => _134,
  "72": () => _25,
  "728": () => _282,
  "729": () => _292,
  "73": () => _36,
  "730": () => _302,
  "731": () => _312,
  "732": () => _323,
  "733": () => _333,
  "74": () => _45,
  "75": () => _55,
  "76": () => _65,
  "77": () => _75,
  "78": () => _85,
  "79": () => _95,
  "80": () => _05,
  "81": () => _15,
  "82": () => _26,
  "8211": () => _211,
  "8212": () => _2122,
  "8216": () => _216,
  "8217": () => _217,
  "8218": () => _218,
  "8220": () => _220,
  "8221": () => _221,
  "8222": () => _2222,
  "8224": () => _2242,
  "8225": () => _225,
  "8226": () => _226,
  "8230": () => _230,
  "8240": () => _240,
  "8249": () => _249,
  "8250": () => _250,
  "8260": () => _260,
  "83": () => _37,
  "8364": () => _364,
  "84": () => _46,
  "8482": () => _482,
  "8486": () => _486,
  "85": () => _56,
  "86": () => _66,
  "87": () => _76,
  "8706": () => _706,
  "8710": () => _710,
  "8719": () => _719,
  "8721": () => _721,
  "8722": () => _7222,
  "8730": () => _730,
  "8734": () => _734,
  "8747": () => _747,
  "8776": () => _776,
  "88": () => _86,
  "8800": () => _800,
  "8804": () => _804,
  "8805": () => _805,
  "89": () => _96,
  "90": () => _06,
  "91": () => _16,
  "92": () => _27,
  "93": () => _38,
  "94": () => _47,
  "95": () => _57,
  "96": () => _67,
  "960": () => _603,
  "9674": () => _674,
  "97": () => _77,
  "98": () => _87,
  "9833": () => _833,
  "99": () => _97,
  avg: () => avg,
  default: () => Lato12Regular_default
});
var _ = 0;
var _3 = 0;
var _2 = 2.316;
var _32 = 4.116;
var _4 = 4.764;
var _5 = 6.96;
var _6 = 6.96;
var _7 = 9.432;
var _8 = 8.436;
var _9 = 2.7600000000000002;
var _0 = 3.6;
var _1 = 3.6;
var _22 = 4.8;
var _33 = 6.96;
var _42 = 2.544;
var _52 = 4.164;
var _62 = 2.544;
var _72 = 4.476;
var _82 = 6.96;
var _92 = 6.96;
var _02 = 6.96;
var _12 = 6.96;
var _23 = 6.96;
var _34 = 6.96;
var _43 = 6.96;
var _53 = 6.96;
var _63 = 6.96;
var _73 = 6.96;
var _83 = 3.024;
var _93 = 3.024;
var _03 = 6.96;
var _13 = 6.96;
var _24 = 6.96;
var _35 = 4.776;
var _44 = 9.864;
var _54 = 8.16;
var _64 = 7.764;
var _74 = 8.22;
var _84 = 9.036;
var _94 = 6.972;
var _04 = 6.792;
var _14 = 8.808;
var _25 = 9.072000000000001;
var _36 = 3.684;
var _45 = 5.328;
var _55 = 8.172;
var _65 = 6.168;
var _75 = 11.040000000000001;
var _85 = 9.072000000000001;
var _95 = 9.576;
var _05 = 7.332;
var _15 = 9.576;
var _26 = 7.728;
var _37 = 6.36;
var _46 = 7.08;
var _56 = 8.76;
var _66 = 8.16;
var _76 = 12.228;
var _86 = 7.716;
var _96 = 7.548;
var _06 = 7.488;
var _16 = 3.6;
var _27 = 4.5;
var _38 = 3.6;
var _47 = 6.96;
var _57 = 4.728;
var _67 = 3.684;
var _77 = 6.0840000000000005;
var _87 = 6.708;
var _97 = 5.604;
var _00 = 6.708;
var _01 = 6.288;
var _022 = 4.0440000000000005;
var _032 = 6.132000000000001;
var _042 = 6.672;
var _052 = 3.072;
var _062 = 3.048;
var _07 = 6.288;
var _08 = 3.072;
var _09 = 9.852;
var _10 = 6.672;
var _11 = 6.672;
var _122 = 6.6240000000000006;
var _132 = 6.708;
var _142 = 4.836;
var _152 = 5.208;
var _162 = 4.476;
var _17 = 6.672;
var _18 = 6.144;
var _19 = 9.192;
var _20 = 6.048;
var _21 = 6.144;
var _222 = 5.5440000000000005;
var _232 = 3.6;
var _242 = 3.6;
var _252 = 3.6;
var _262 = 6.96;
var _60 = 2.316;
var _61 = 4.116;
var _622 = 6.96;
var _632 = 6.96;
var _642 = 6.96;
var _652 = 6.96;
var _662 = 3.6;
var _672 = 6.0360000000000005;
var _68 = 3.684;
var _69 = 9.576;
var _70 = 4.104;
var _71 = 5.556;
var _722 = 6.96;
var _732 = 4.164;
var _742 = 9.576;
var _752 = 3.684;
var _762 = 4.764;
var _772 = 6.96;
var _78 = 3.984;
var _79 = 3.984;
var _80 = 3.684;
var _81 = 6.672;
var _822 = 8.028;
var _832 = 3.2760000000000002;
var _842 = 3.684;
var _852 = 3.984;
var _862 = 4.572;
var _872 = 5.556;
var _88 = 8.544;
var _89 = 8.544;
var _90 = 8.556000000000001;
var _91 = 4.776;
var _922 = 8.16;
var _932 = 8.16;
var _942 = 8.16;
var _952 = 8.16;
var _962 = 8.16;
var _972 = 8.16;
var _98 = 11.148;
var _99 = 8.22;
var _002 = 6.972;
var _012 = 6.972;
var _023 = 6.972;
var _033 = 6.972;
var _043 = 3.684;
var _053 = 3.684;
var _063 = 3.684;
var _072 = 3.684;
var _082 = 9.468;
var _092 = 9.072000000000001;
var _102 = 9.576;
var _112 = 9.576;
var _123 = 9.576;
var _133 = 9.576;
var _143 = 9.576;
var _153 = 6.96;
var _163 = 9.576;
var _172 = 8.76;
var _182 = 8.76;
var _192 = 8.76;
var _202 = 8.76;
var _212 = 7.548;
var _223 = 7.332;
var _233 = 7.308;
var _243 = 6.0840000000000005;
var _253 = 6.0840000000000005;
var _263 = 6.0840000000000005;
var _272 = 6.0840000000000005;
var _28 = 6.0840000000000005;
var _29 = 6.0840000000000005;
var _30 = 9.792;
var _31 = 5.604;
var _322 = 6.288;
var _332 = 6.288;
var _342 = 6.288;
var _352 = 6.288;
var _362 = 3.072;
var _372 = 3.072;
var _382 = 3.072;
var _39 = 3.072;
var _40 = 6.636;
var _41 = 6.672;
var _422 = 6.672;
var _432 = 6.672;
var _442 = 6.672;
var _452 = 6.672;
var _462 = 6.672;
var _472 = 6.96;
var _48 = 6.672;
var _49 = 6.672;
var _50 = 6.672;
var _51 = 6.672;
var _522 = 6.672;
var _532 = 6.144;
var _542 = 6.6240000000000006;
var _552 = 6.144;
var _602 = 8.16;
var _612 = 6.0840000000000005;
var _623 = 8.22;
var _633 = 5.604;
var _802 = 7.128;
var _812 = 6.288;
var _054 = 3.072;
var _213 = 6.516;
var _224 = 3.852;
var _234 = 9.072000000000001;
var _244 = 6.672;
var _383 = 13.152000000000001;
var _392 = 10.404;
var _463 = 6.5760000000000005;
var _473 = 5.208;
var _523 = 6.36;
var _533 = 5.208;
var _763 = 7.548;
var _773 = 7.488;
var _782 = 5.5440000000000005;
var _792 = 7.488;
var _803 = 5.5440000000000005;
var _813 = 7.488;
var _823 = 5.5440000000000005;
var _024 = 6.96;
var _103 = 3.684;
var _113 = 3.684;
var _134 = 3.684;
var _282 = 3.684;
var _292 = 3.684;
var _302 = 3.684;
var _312 = 3.684;
var _323 = 3.684;
var _333 = 3.684;
var _603 = 7.416;
var _211 = 6.672;
var _2122 = 9.852;
var _216 = 2.544;
var _217 = 2.544;
var _218 = 2.544;
var _220 = 4.368;
var _221 = 4.368;
var _2222 = 4.368;
var _2242 = 6.96;
var _225 = 6.96;
var _226 = 6.96;
var _230 = 8.724;
var _240 = 13.836;
var _249 = 3.7920000000000003;
var _250 = 3.7920000000000003;
var _260 = 3.684;
var _364 = 6.96;
var _482 = 8.64;
var _486 = 8.964;
var _706 = 6.96;
var _710 = 8.352;
var _719 = 8.208;
var _721 = 8.208;
var _7222 = 6.96;
var _730 = 6.876;
var _734 = 8.208;
var _747 = 4.8;
var _776 = 6.96;
var _800 = 6.96;
var _804 = 6.96;
var _805 = 6.96;
var _674 = 6.96;
var _833 = 0;
var _4257 = 6.84;
var _4258 = 7.128;
var avg = 6.3101292775665465;
var Lato12Regular_default = {
  "0": _,
  "13": _3,
  "32": _2,
  "33": _32,
  "34": _4,
  "35": _5,
  "36": _6,
  "37": _7,
  "38": _8,
  "39": _9,
  "40": _0,
  "41": _1,
  "42": _22,
  "43": _33,
  "44": _42,
  "45": _52,
  "46": _62,
  "47": _72,
  "48": _82,
  "49": _92,
  "50": _02,
  "51": _12,
  "52": _23,
  "53": _34,
  "54": _43,
  "55": _53,
  "56": _63,
  "57": _73,
  "58": _83,
  "59": _93,
  "60": _03,
  "61": _13,
  "62": _24,
  "63": _35,
  "64": _44,
  "65": _54,
  "66": _64,
  "67": _74,
  "68": _84,
  "69": _94,
  "70": _04,
  "71": _14,
  "72": _25,
  "73": _36,
  "74": _45,
  "75": _55,
  "76": _65,
  "77": _75,
  "78": _85,
  "79": _95,
  "80": _05,
  "81": _15,
  "82": _26,
  "83": _37,
  "84": _46,
  "85": _56,
  "86": _66,
  "87": _76,
  "88": _86,
  "89": _96,
  "90": _06,
  "91": _16,
  "92": _27,
  "93": _38,
  "94": _47,
  "95": _57,
  "96": _67,
  "97": _77,
  "98": _87,
  "99": _97,
  "100": _00,
  "101": _01,
  "102": _022,
  "103": _032,
  "104": _042,
  "105": _052,
  "106": _062,
  "107": _07,
  "108": _08,
  "109": _09,
  "110": _10,
  "111": _11,
  "112": _122,
  "113": _132,
  "114": _142,
  "115": _152,
  "116": _162,
  "117": _17,
  "118": _18,
  "119": _19,
  "120": _20,
  "121": _21,
  "122": _222,
  "123": _232,
  "124": _242,
  "125": _252,
  "126": _262,
  "160": _60,
  "161": _61,
  "162": _622,
  "163": _632,
  "164": _642,
  "165": _652,
  "166": _662,
  "167": _672,
  "168": _68,
  "169": _69,
  "170": _70,
  "171": _71,
  "172": _722,
  "173": _732,
  "174": _742,
  "175": _752,
  "176": _762,
  "177": _772,
  "178": _78,
  "179": _79,
  "180": _80,
  "181": _81,
  "182": _822,
  "183": _832,
  "184": _842,
  "185": _852,
  "186": _862,
  "187": _872,
  "188": _88,
  "189": _89,
  "190": _90,
  "191": _91,
  "192": _922,
  "193": _932,
  "194": _942,
  "195": _952,
  "196": _962,
  "197": _972,
  "198": _98,
  "199": _99,
  "200": _002,
  "201": _012,
  "202": _023,
  "203": _033,
  "204": _043,
  "205": _053,
  "206": _063,
  "207": _072,
  "208": _082,
  "209": _092,
  "210": _102,
  "211": _112,
  "212": _123,
  "213": _133,
  "214": _143,
  "215": _153,
  "216": _163,
  "217": _172,
  "218": _182,
  "219": _192,
  "220": _202,
  "221": _212,
  "222": _223,
  "223": _233,
  "224": _243,
  "225": _253,
  "226": _263,
  "227": _272,
  "228": _28,
  "229": _29,
  "230": _30,
  "231": _31,
  "232": _322,
  "233": _332,
  "234": _342,
  "235": _352,
  "236": _362,
  "237": _372,
  "238": _382,
  "239": _39,
  "240": _40,
  "241": _41,
  "242": _422,
  "243": _432,
  "244": _442,
  "245": _452,
  "246": _462,
  "247": _472,
  "248": _48,
  "249": _49,
  "250": _50,
  "251": _51,
  "252": _522,
  "253": _532,
  "254": _542,
  "255": _552,
  "260": _602,
  "261": _612,
  "262": _623,
  "263": _633,
  "280": _802,
  "281": _812,
  "305": _054,
  "321": _213,
  "322": _224,
  "323": _234,
  "324": _244,
  "338": _383,
  "339": _392,
  "346": _463,
  "347": _473,
  "352": _523,
  "353": _533,
  "376": _763,
  "377": _773,
  "378": _782,
  "379": _792,
  "380": _803,
  "381": _813,
  "382": _823,
  "402": _024,
  "710": _103,
  "711": _113,
  "713": _134,
  "728": _282,
  "729": _292,
  "730": _302,
  "731": _312,
  "732": _323,
  "733": _333,
  "960": _603,
  "8211": _211,
  "8212": _2122,
  "8216": _216,
  "8217": _217,
  "8218": _218,
  "8220": _220,
  "8221": _221,
  "8222": _2222,
  "8224": _2242,
  "8225": _225,
  "8226": _226,
  "8230": _230,
  "8240": _240,
  "8249": _249,
  "8250": _250,
  "8260": _260,
  "8364": _364,
  "8482": _482,
  "8486": _486,
  "8706": _706,
  "8710": _710,
  "8719": _719,
  "8721": _721,
  "8722": _7222,
  "8730": _730,
  "8734": _734,
  "8747": _747,
  "8776": _776,
  "8800": _800,
  "8804": _804,
  "8805": _805,
  "9674": _674,
  "9833": _833,
  "64257": _4257,
  "64258": _4258,
  avg
};

// src/components/ReactPdfInvoice/measure.ts
var isValidCharCode = (key) => {
  return key in Lato12Regular_exports;
};
var estimateCharacterWidth = (character) => {
  const charCode = character.charCodeAt(0).toString();
  if (isValidCharCode(charCode)) {
    return Lato12Regular_exports[charCode];
  }
  return avg;
};
var estimateStringWidth = (str) => str.split("").map((char) => estimateCharacterWidth(char)).reduce((acc, cur) => acc + cur, 0);
var estimateColumnWidth = (strings) => {
  if (strings.length === 0) {
    return 0;
  }
  return Math.max(...strings.map(estimateStringWidth));
};
var clampWidth = ({
  minWidth,
  width
}) => {
  if (typeof minWidth !== "undefined" && width < minWidth) {
    return minWidth;
  }
  return width;
};
var estimateLineItemColumnWidths = ({
  lineItems,
  currency
}) => {
  return {
    description: 0,
    quantity: estimateColumnWidth(
      lineItems.map((lineItem) => renderQuantity({ lineItem, currency }))
    ),
    rate: estimateColumnWidth(
      lineItems.map((lineItem) => renderRate({ lineItem, currency }))
    ),
    taxRate: estimateColumnWidth(
      lineItems.map((lineItem) => renderTaxRate({ lineItem }))
    ),
    netTotal: estimateColumnWidth(
      lineItems.map((lineItem) => renderNetTotal({ lineItem, currency }))
    )
  };
};

// src/components/ReactPdfInvoice/LineItems/LineItemRow.tsx
import { Fragment as Fragment11, jsx as jsx40, jsxs as jsxs34 } from "react/jsx-runtime";
var LineItemRow = ({
  lineItem,
  invoiceOrCreditNote,
  columnWidths
}) => {
  const { currency } = invoiceOrCreditNote;
  return /* @__PURE__ */ jsx40(Fragment11, { children: /* @__PURE__ */ jsxs34(TableRow, { borderBottom: GreyGrey303, children: [
    /* @__PURE__ */ jsx40(
      TableCell,
      {
        value: lineItem.title,
        secondaryValue: lineItem.description,
        wrap: true,
        paddingLeft: DEFAULT_COLUMNS.description.paddingLeft,
        textAlign: DEFAULT_COLUMNS.description.textAlign
      }
    ),
    /* @__PURE__ */ jsx40(
      TableCell,
      {
        value: renderQuantity({ lineItem, currency }),
        width: clampWidth({
          minWidth: DEFAULT_COLUMNS.quantity.width,
          width: columnWidths.quantity
        })
      }
    ),
    /* @__PURE__ */ jsx40(
      TableCell,
      {
        value: renderRate({ lineItem, currency }),
        width: clampWidth({
          minWidth: DEFAULT_COLUMNS.rate.width,
          width: columnWidths.rate
        })
      }
    ),
    /* @__PURE__ */ jsx40(
      TableCell,
      {
        value: renderTaxRate({ lineItem }),
        width: clampWidth({
          minWidth: DEFAULT_COLUMNS.taxRate.width,
          width: columnWidths.taxRate
        })
      }
    ),
    /* @__PURE__ */ jsx40(
      TableCell,
      {
        value: renderNetTotal({ lineItem, currency }),
        width: clampWidth({
          minWidth: DEFAULT_COLUMNS.netTotal.width,
          width: columnWidths.netTotal
        }),
        paddingRight: DEFAULT_COLUMNS.netTotal.paddingRight
      }
    )
  ] }) });
};

// src/components/ReactPdfInvoice/LineItems/LineItems.tsx
import { View as View23 } from "@react-pdf/renderer";
import {
  toMoney as toMoney5
} from "@sequencehq/core-models";
import { jsx as jsx41, jsxs as jsxs35 } from "react/jsx-runtime";
var LineItems = ({
  type,
  invoiceOrCreditNote,
  lineItemGroups,
  lineItems,
  refTotalsPage
}) => {
  const { currency } = invoiceOrCreditNote;
  const lineItemsUngrouped = lineItems.filter((lineItem) => !lineItem.groupId);
  const lineItemsUngroupedNetTotal = lineItemsUngrouped.reduce((acc, cur) => {
    return acc + Number(cur.netTotal);
  }, 0).toString();
  const columnWidthsUngrouped = estimateLineItemColumnWidths({
    lineItems: lineItemsUngrouped,
    currency
  });
  return /* @__PURE__ */ jsxs35(View23, { style: { gap: 12 }, children: [
    lineItemsUngrouped.length > 0 && /* @__PURE__ */ jsxs35(Table, { children: [
      /* @__PURE__ */ jsx41(LineItemsHeaderRow, { columnWidths: columnWidthsUngrouped }),
      lineItemsUngrouped.map((lineItem) => /* @__PURE__ */ jsx41(
        LineItemRow,
        {
          lineItem,
          invoiceOrCreditNote,
          columnWidths: columnWidthsUngrouped
        },
        lineItem.id
      )),
      /* @__PURE__ */ jsx41(
        LineItemsSubtotalRow,
        {
          subtotal: toMoney5({ currency, value: lineItemsUngroupedNetTotal })
        }
      )
    ] }),
    lineItemGroups.map((lineItemGroup) => {
      const lineItemsForGroup = lineItems.filter(
        (lineItem) => lineItem.groupId === lineItemGroup.id
      );
      const columnWidths = estimateLineItemColumnWidths({
        lineItems: lineItemsForGroup,
        currency
      });
      return /* @__PURE__ */ jsxs35(Table, { primaryText: lineItemGroup.title, children: [
        /* @__PURE__ */ jsx41(LineItemsHeaderRow, { columnWidths }),
        lineItemsForGroup.map((lineItem) => /* @__PURE__ */ jsx41(
          LineItemRow,
          {
            lineItem,
            invoiceOrCreditNote,
            columnWidths
          },
          lineItem.id
        )),
        /* @__PURE__ */ jsx41(
          LineItemsSubtotalRow,
          {
            subtotal: toMoney5({ currency, value: lineItemGroup.netTotal })
          }
        )
      ] }, lineItemGroup.id);
    }),
    /* @__PURE__ */ jsx41(
      Totals,
      {
        type,
        invoiceOrCreditNote,
        refTotalsPage
      }
    )
  ] });
};

// src/components/ReactPdfInvoice/LineItems/LineItemsHeaderRow.tsx
import { GreyGrey50 } from "@sequencehq/design-tokens";
import { jsx as jsx42 } from "react/jsx-runtime";
var { lato12RegularGreyGrey60: lato12RegularGreyGrey604 } = Styles_default;
var LineItemsHeaderRow = ({
  columnWidths
}) => /* @__PURE__ */ jsx42(TableRow, { borderBottom: GreyGrey50, children: Object.keys(DEFAULT_COLUMNS).map((key, index) => {
  const row = DEFAULT_COLUMNS[key];
  return /* @__PURE__ */ jsx42(
    TableCell,
    {
      value: row.value,
      width: (
        /**
         * Allow the line item title and description rows to take up as much space as they want
         */
        index === 0 ? row.width : clampWidth({
          minWidth: row.width,
          width: columnWidths[key]
        })
      ),
      paddingLeft: row.paddingLeft,
      paddingRight: row.paddingRight,
      textAlign: row.textAlign,
      fontStyle: lato12RegularGreyGrey604
    },
    row.value
  );
}) });

// src/components/ReactPdfInvoice/LineItems/LineItemsSubtotalRow.tsx
import { jsx as jsx43, jsxs as jsxs36 } from "react/jsx-runtime";
var { lato12BoldGreyGrey100: lato12BoldGreyGrey1003 } = Styles_default;
var LineItemsSubtotalRow = ({ subtotal }) => /* @__PURE__ */ jsxs36(TableRow, { children: [
  /* @__PURE__ */ jsx43(
    TableCell,
    {
      value: "Subtotal",
      paddingLeft: 0,
      textAlign: "left",
      fontStyle: lato12BoldGreyGrey1003
    }
  ),
  /* @__PURE__ */ jsx43(
    TableCell,
    {
      value: subtotal,
      fontStyle: lato12BoldGreyGrey1003,
      paddingRight: 0
    }
  )
] });

// src/components/ReactPdfInvoice/Watermarks/Watermark.tsx
import { View as View24, Text as Text27 } from "@react-pdf/renderer";
import { jsx as jsx44 } from "react/jsx-runtime";
var { watermark, watermarkText } = Styles_default;
var Watermark = ({ text }) => /* @__PURE__ */ jsx44(View24, { style: watermark, fixed: true, children: /* @__PURE__ */ jsx44(Text27, { style: watermarkText, children: text }) });

// src/components/ReactPdfInvoice/Watermarks/Watermarks.tsx
import { Fragment as Fragment12, jsx as jsx45, jsxs as jsxs37 } from "react/jsx-runtime";
var Watermarks = ({
  entity,
  showNonProdWatermark
}) => /* @__PURE__ */ jsxs37(Fragment12, { children: [
  entity.status === "DRAFT" && /* @__PURE__ */ jsx45(Watermark, { text: "Draft" }),
  entity.status === "VOIDED" && /* @__PURE__ */ jsx45(Watermark, { text: "Void" }),
  showNonProdWatermark && /* @__PURE__ */ jsx45(Watermark, { text: "Test" })
] });

// src/components/ReactPdfInvoice/PageTypes/PageSubAccountUsageBreakdown/PageSubAccountUsageBreakdown.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var PageSubAccountUsageBreakdown = ({
  pageAccent: pageAccent2,
  footerString,
  refTotalsPage,
  watermarks,
  subAccountUsageBreakdown
}) => {
  return /* @__PURE__ */ jsx46(
    PageLayoutSecondary,
    {
      accent: pageAccent2,
      header: /* @__PURE__ */ jsx46(PageLayoutSecondaryHeader, { title: "Sub account usage" }),
      footerString,
      refTotalsPage,
      watermarks,
      type: "invoice",
      children: subAccountUsageBreakdown.map((usageBreakdown) => /* @__PURE__ */ jsx46(
        PageLayoutSecondaryGroup,
        {
          title: usageBreakdown.subAccountLabel,
          children: usageBreakdown.usageData.map((usage) => /* @__PURE__ */ jsx46(
            PageLayoutSecondaryLine,
            {
              title: usage.label,
              content: usage.quantity
            },
            `${usage.label}-${usage.quantity}`
          ))
        },
        usageBreakdown.subAccountLabel
      ))
    }
  );
};

// src/components/ReactPdfInvoice/ReactPdfInvoice.tsx
import { registerReactPdfFonts } from "@sequencehq/utils";
import { jsx as jsx47, jsxs as jsxs38 } from "react/jsx-runtime";
registerReactPdfFonts();
var ReactPdfInvoice = ({
  invoice,
  lineItems,
  lineItemGroups,
  merchantDetails,
  currencyConversions = [],
  urlRootApi,
  urlRootCustomerPortal,
  creditBalances,
  defaultDueDateDays,
  isCustomerPortalEnabled,
  showNonProdWatermark,
  setExternalPaymentDetailsPageNumber,
  externalPaymentDetailsPageNumber,
  isRenderedInBrowser,
  subAccountUsageBreakdown
}) => {
  const merchantDetailsToUse = getMerchantDetailsToUse({
    invoice,
    merchantDetails
  });
  const refTotalsPage = useRef();
  const [paymentDetailsPage, setPaymentDetailsPage] = useState(0);
  const pageAccent2 = /* @__PURE__ */ jsx47(PageAccent, { merchantDetails: merchantDetailsToUse });
  const invoiceNumber = renderInvoiceNumber(invoice.invoiceNumber);
  const footerString = `${invoiceNumber} \u2014 ${toMoney6({
    currency: invoice.currency,
    value: invoice.grossTotal
  })} due ${localDateWithFormat5(invoice.dueDate, "d MMMM yyyy")}`;
  const hasPaymentDetailsPage = hasPaymentsDetailsPage(merchantDetailsToUse);
  const hasCurrencyConversionsPage = currencyConversions.length > 0;
  const watermarks = /* @__PURE__ */ jsx47(Watermarks, { entity: invoice, showNonProdWatermark });
  return /* @__PURE__ */ jsxs38(Document, { children: [
    /* @__PURE__ */ jsx47(
      PageLayout,
      {
        type: "invoice",
        accent: pageAccent2,
        footerString,
        refTotalsPage,
        watermarks,
        children: /* @__PURE__ */ jsxs38(View25, { style: { marginTop: -8 }, children: [
          /* @__PURE__ */ jsx47(
            Header,
            {
              type: "invoice",
              merchantDetails: merchantDetailsToUse,
              isRenderedInBrowser
            }
          ),
          /* @__PURE__ */ jsx47(
            Summary,
            {
              type: "invoice",
              invoiceOrCreditNote: invoice,
              merchantDetails: merchantDetailsToUse,
              defaultDueDateDays
            }
          ),
          /* @__PURE__ */ jsx47(
            PaymentOverview,
            {
              type: "invoice",
              invoiceOrCreditNote: invoice,
              urlRootApi,
              urlRootCustomerPortal,
              paymentDetailsPage,
              externalPaymentDetailsPageNumber,
              isCustomerPortalEnabled
            }
          ),
          /* @__PURE__ */ jsx47(
            LineItems,
            {
              type: "invoice",
              invoiceOrCreditNote: invoice,
              lineItems,
              lineItemGroups,
              refTotalsPage
            }
          )
        ] })
      }
    ),
    hasCurrencyConversionsPage && /* @__PURE__ */ jsx47(
      PageCurrencyConversions,
      {
        pageAccent: pageAccent2,
        footerString,
        refTotalsPage,
        watermarks,
        currencyConversions
      }
    ),
    creditBalances.map((creditBalance) => /* @__PURE__ */ jsx47(
      PageCreditBalance,
      {
        pageAccent: pageAccent2,
        footerString,
        refTotalsPage,
        watermarks,
        creditBalance
      },
      creditBalance.id
    )),
    hasPaymentDetailsPage && /* @__PURE__ */ jsx47(
      PagePaymentDetails,
      {
        pageAccent: pageAccent2,
        footerString,
        refTotalsPage,
        invoice,
        merchantDetails: merchantDetailsToUse,
        watermarks,
        setPaymentDetailsPage,
        setExternalPaymentDetailsPageNumber
      }
    ),
    subAccountUsageBreakdown?.length && /* @__PURE__ */ jsx47(
      PageSubAccountUsageBreakdown,
      {
        pageAccent: pageAccent2,
        footerString,
        refTotalsPage,
        watermarks,
        subAccountUsageBreakdown
      }
    )
  ] });
};

// src/components/ReactPdfInvoice/ReactPdfCreditNote.tsx
import { Document as Document2, View as View26 } from "@react-pdf/renderer";
import { toMoney as toMoney7 } from "@sequencehq/core-models";
import { registerReactPdfFonts as registerReactPdfFonts2 } from "@sequencehq/utils/src/pdfs";
import { useRef as useRef2 } from "react";
import { jsx as jsx48, jsxs as jsxs39 } from "react/jsx-runtime";
registerReactPdfFonts2();
var ReactPdfCreditNote = ({
  creditNote,
  lineItems,
  lineItemGroups,
  merchantDetails,
  isCustomerPortalEnabled,
  showNonProdWatermark,
  isRenderedInBrowser
}) => {
  const pageAccent2 = /* @__PURE__ */ jsx48(PageAccent, { merchantDetails });
  const refTotalsPage = useRef2();
  const creditNoteNumber = renderInvoiceNumber(creditNote.creditNoteNumber);
  const footerString = `${creditNoteNumber} \u2014 ${toMoney7({
    currency: creditNote.currency,
    value: creditNote.grossTotal
  })}`;
  return /* @__PURE__ */ jsx48(Document2, { children: /* @__PURE__ */ jsx48(
    PageLayout,
    {
      type: "creditNote",
      accent: pageAccent2,
      footerString,
      refTotalsPage,
      watermarks: /* @__PURE__ */ jsx48(
        Watermarks,
        {
          entity: creditNote,
          showNonProdWatermark
        }
      ),
      children: /* @__PURE__ */ jsxs39(View26, { style: { marginTop: -8 }, children: [
        /* @__PURE__ */ jsx48(
          Header,
          {
            merchantDetails,
            type: "creditNote",
            isRenderedInBrowser
          }
        ),
        /* @__PURE__ */ jsx48(
          Summary,
          {
            type: "creditNote",
            invoiceOrCreditNote: creditNote,
            merchantDetails
          }
        ),
        /* @__PURE__ */ jsx48(
          PaymentOverview,
          {
            type: "creditNote",
            invoiceOrCreditNote: creditNote,
            isCustomerPortalEnabled
          }
        ),
        /* @__PURE__ */ jsx48(
          LineItems,
          {
            type: "creditNote",
            invoiceOrCreditNote: creditNote,
            lineItems,
            lineItemGroups,
            refTotalsPage
          }
        )
      ] })
    }
  ) });
};

// src/components/ReactPdfInvoice/DownloadButtons/InvoiceDownloadButton.tsx
import { PDFDownloadLink } from "@react-pdf/renderer";
import { jsx as jsx49 } from "react/jsx-runtime";
var InvoiceDownloadButton = ({
  invoice,
  lineItems,
  lineItemGroups,
  merchantDetails,
  urlRootCustomerPortal,
  urlRootApi,
  children,
  creditBalances,
  defaultDueDateDays,
  showNonProdWatermark,
  isCustomerPortalEnabled,
  subAccountUsageBreakdown
}) => {
  return /* @__PURE__ */ jsx49(
    PDFDownloadLink,
    {
      download: `${invoice.invoiceNumber || "Invoice"}.pdf`,
      document: /* @__PURE__ */ jsx49(
        ReactPdfInvoice,
        {
          invoice,
          lineItems,
          lineItemGroups,
          merchantDetails,
          urlRootCustomerPortal,
          urlRootApi,
          creditBalances,
          defaultDueDateDays,
          showNonProdWatermark,
          isCustomerPortalEnabled,
          isRenderedInBrowser: true,
          subAccountUsageBreakdown
        }
      ),
      children
    }
  );
};

// src/components/ReactPdfInvoice/DownloadButtons/CreditNoteDownloadButton.tsx
import { PDFDownloadLink as PDFDownloadLink2 } from "@react-pdf/renderer";
import { jsx as jsx50 } from "react/jsx-runtime";
var CreditNoteDownloadButton = ({
  creditNote,
  lineItems,
  lineItemGroups,
  merchantDetails,
  showNonProdWatermark,
  isCustomerPortalEnabled,
  children
}) => {
  return /* @__PURE__ */ jsx50(
    PDFDownloadLink2,
    {
      download: `${creditNote.creditNoteNumber || "Credit Note"}.pdf`,
      document: /* @__PURE__ */ jsx50(
        ReactPdfCreditNote,
        {
          creditNote,
          lineItems,
          lineItemGroups,
          merchantDetails,
          showNonProdWatermark,
          isCustomerPortalEnabled,
          isRenderedInBrowser: true
        }
      ),
      children
    }
  );
};

// src/components/InvoiceV2/GroupSummary/GroupSummary.tsx
import { Flex as Flex7, Text as Text28 } from "@chakra-ui/react";
import {
  GreyGrey10,
  GreyGrey30 as GreyGrey304,
  GreyGrey70,
  GreyGrey80 as GreyGrey802,
  Lato14Bold,
  Lato14Regular,
  Lato16Bold as Lato16Bold2
} from "@sequencehq/design-tokens";
import { jsx as jsx51, jsxs as jsxs40 } from "react/jsx-runtime";
var defaultStyles = {
  billingPeriodTextColor: GreyGrey802,
  groupSummaryLineTextLeftColor: GreyGrey70,
  groupSummaryLineTextRightColor: GreyGrey802,
  separatorBorderColor: GreyGrey304,
  grossTotalTextColor: GreyGrey802
};
var getStyle = (key, styles2) => {
  return styles2?.[key] ?? defaultStyles[key];
};
var GroupSummaryLine = ({
  description,
  amount,
  styles: styles2
}) => /* @__PURE__ */ jsxs40(Flex7, { justify: "space-between", children: [
  /* @__PURE__ */ jsx51(
    Text28,
    {
      ...Lato14Regular,
      color: getStyle("groupSummaryLineTextLeftColor", styles2),
      children: description
    }
  ),
  /* @__PURE__ */ jsx51(
    Text28,
    {
      ...Lato14Regular,
      color: getStyle("groupSummaryLineTextRightColor", styles2),
      children: amount
    }
  )
] });
var GroupSummary = ({
  billingPeriod,
  groupSummary,
  totals,
  styles: styles2
}) => {
  const hasBillingPeriod = Boolean(billingPeriod);
  const hasGroupSummaryItems = Boolean(groupSummary.length);
  const hasBillingPeriodOrGroupSummaryItems = hasBillingPeriod || hasGroupSummaryItems;
  return /* @__PURE__ */ jsxs40(
    Flex7,
    {
      backgroundColor: GreyGrey10,
      borderRadius: "8px",
      direction: "column",
      gap: "16px",
      padding: "16px",
      children: [
        hasBillingPeriod && /* @__PURE__ */ jsx51(
          Text28,
          {
            ...Lato14Bold,
            color: getStyle("billingPeriodTextColor", styles2),
            children: billingPeriod
          }
        ),
        hasGroupSummaryItems && /* @__PURE__ */ jsx51(Flex7, { flexDirection: "column", gap: "12px", children: groupSummary.map(({ description, total }, index) => /* @__PURE__ */ jsx51(
          GroupSummaryLine,
          {
            description,
            amount: total,
            styles: styles2
          },
          index
        )) }),
        /* @__PURE__ */ jsxs40(Flex7, { flexDirection: "column", gap: "12px", children: [
          /* @__PURE__ */ jsxs40(
            Flex7,
            {
              flexDirection: "column",
              gap: "12px",
              paddingTop: hasBillingPeriodOrGroupSummaryItems ? "12px" : "0px",
              paddingBottom: "12px",
              borderTop: hasBillingPeriodOrGroupSummaryItems ? `${getStyle("separatorBorderColor", styles2)} 1px solid` : "none",
              borderBottom: `${getStyle("separatorBorderColor", styles2)} 1px solid`,
              children: [
                /* @__PURE__ */ jsx51(
                  GroupSummaryLine,
                  {
                    description: "Subtotal",
                    amount: totals.netTotal,
                    styles: styles2
                  }
                ),
                /* @__PURE__ */ jsx51(
                  GroupSummaryLine,
                  {
                    description: totals.taxLabel,
                    amount: totals.totalTax,
                    styles: styles2
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs40(Flex7, { justify: "space-between", align: "center", children: [
            /* @__PURE__ */ jsx51(Text28, { ...Lato14Bold, color: getStyle("grossTotalTextColor", styles2), children: "Total" }),
            /* @__PURE__ */ jsx51(Text28, { ...Lato16Bold2, color: getStyle("grossTotalTextColor", styles2), children: totals.grossTotal })
          ] })
        ] })
      ]
    }
  );
};

// src/components/InvoiceV2/PaymentDetailsDrawer/PaymentDetailsDrawer.tsx
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  Grid,
  Flex as Flex8,
  DrawerCloseButton,
  GridItem,
  Text as Text29,
  Box as Box7,
  Center
} from "@chakra-ui/react";
import {
  GreyGrey30 as GreyGrey305,
  Lato16Bold as Lato16Bold3,
  Lato14ExtendedRegular,
  GreyGrey70 as GreyGrey702,
  GreyGrey80 as GreyGrey803
} from "@sequencehq/design-tokens";
import { CopyButton } from "@sequencehq/core-components";
import { jsx as jsx52, jsxs as jsxs41 } from "react/jsx-runtime";
var PaymentDetailsDrawer = ({
  isOpen,
  onClose,
  footer,
  detailItems
}) => {
  const hasFooter = Boolean(footer);
  return /* @__PURE__ */ jsxs41(Drawer, { isOpen, onClose, children: [
    /* @__PURE__ */ jsx52(
      DrawerOverlay,
      {
        display: "flex",
        alignContent: "center",
        justifyContent: "center"
      }
    ),
    /* @__PURE__ */ jsx52(
      DrawerContent,
      {
        margin: "8px 12px",
        borderRadius: "8px",
        style: {
          width: "fit-content",
          maxWidth: "100%",
          minWidth: "550px"
        },
        children: /* @__PURE__ */ jsxs41(
          Grid,
          {
            templateAreas: `
            "header"
            "content"
            ${hasFooter ? '"footer"' : ""}
          `,
            templateRows: ["56px", "1fr", ...hasFooter ? ["64px"] : []].join(
              " "
            ),
            width: "100%",
            height: "100%",
            children: [
              /* @__PURE__ */ jsxs41(
                Flex8,
                {
                  gridArea: "header",
                  borderBottom: `1px solid ${GreyGrey305}`,
                  ...Lato16Bold3,
                  height: "56px",
                  px: "24px",
                  alignItems: "center",
                  justify: "space-between",
                  children: [
                    "Bank payment details",
                    /* @__PURE__ */ jsx52(
                      DrawerCloseButton,
                      {
                        style: {
                          position: "inherit"
                        }
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx52(GridItem, { gridArea: "content", overflow: "auto", children: /* @__PURE__ */ jsx52(Flex8, { gap: "24px", padding: "24px", direction: "column", children: detailItems.map((accountDetail) => /* @__PURE__ */ jsxs41(
                Flex8,
                {
                  gap: "16px",
                  direction: "column",
                  children: [
                    /* @__PURE__ */ jsx52(Text29, { ...Lato16Bold3, children: accountDetail.description }),
                    /* @__PURE__ */ jsx52(Flex8, { gap: "12px", direction: "column", children: accountDetail.fields.map((accountDetailField) => /* @__PURE__ */ jsxs41(
                      Flex8,
                      {
                        gap: "8px",
                        sx: {
                          ".pdd-row:hover .pdd-row-copy": {
                            display: "block"
                          }
                        },
                        children: [
                          /* @__PURE__ */ jsx52(
                            Text29,
                            {
                              ...Lato14ExtendedRegular,
                              color: GreyGrey702,
                              flex: 1,
                              children: accountDetailField.label
                            }
                          ),
                          /* @__PURE__ */ jsxs41(Flex8, { flex: 1, gap: "4px", className: "pdd-row", children: [
                            /* @__PURE__ */ jsx52(
                              Text29,
                              {
                                as: "span",
                                ...Lato14ExtendedRegular,
                                color: GreyGrey803,
                                children: accountDetailField.value
                              }
                            ),
                            /* @__PURE__ */ jsx52(
                              Center,
                              {
                                position: "relative",
                                width: "24px",
                                flexShrink: "0",
                                children: /* @__PURE__ */ jsx52(
                                  Box7,
                                  {
                                    position: "absolute",
                                    top: "-2px",
                                    right: "0px",
                                    display: "none",
                                    className: "pdd-row-copy",
                                    children: /* @__PURE__ */ jsx52(
                                      CopyButton,
                                      {
                                        value: accountDetailField.value,
                                        enableGroupHover: false
                                      }
                                    )
                                  }
                                )
                              }
                            )
                          ] })
                        ]
                      },
                      accountDetailField.label
                    )) })
                  ]
                },
                accountDetail.description
              )) }) }),
              footer && /* @__PURE__ */ jsx52(
                Flex8,
                {
                  gridArea: "footer",
                  align: "center",
                  gap: "8px",
                  height: "100%",
                  justify: "center",
                  pb: "24px",
                  children: footer
                }
              )
            ]
          }
        )
      }
    )
  ] });
};

// src/components/InvoiceV2/helpers/getPaymentAccountDetails/getPaymentAccountDetails.ts
import {
  accountDetailsTypeDescription
} from "@sequencehq/core-models";
import { formatSortCode } from "@sequencehq/formatters";
import { formatAddress as formatAddress4 } from "@sequencehq/utils";
var getIbanPaymentDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["IBAN"],
    fields: [{ label: "Account name", value: merchantDetails.legalCompanyName }]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  return {
    ...details,
    fields: [
      ...details.fields,
      {
        label: "IBAN",
        value: merchantDetails.iban
      }
    ]
  };
};
var getUkAccountDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["UK_BANK_ACCOUNT"],
    fields: [
      {
        label: "Account name",
        value: merchantDetails.legalCompanyName
      }
    ]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  return {
    ...details,
    fields: [
      ...details.fields,
      {
        label: "Account number",
        value: merchantDetails.ukAccountDetails.accountNumber
      },
      {
        label: "Sort code",
        value: formatSortCode({
          sortCode: merchantDetails.ukAccountDetails.sortCode
        })
      }
    ]
  };
};
var getUsAchDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["US_ACH"],
    fields: [
      {
        label: "Account name",
        value: merchantDetails.usAchDetails.accountName
      }
    ]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  return {
    ...details,
    fields: [
      ...details.fields,
      {
        label: "Account number",
        value: merchantDetails.usAchDetails.accountNumber
      },
      {
        label: "Bank name",
        value: merchantDetails.usAchDetails.bankName
      },
      {
        label: "Bank routing number",
        value: merchantDetails.usAchDetails.bankRoutingNumber
      }
    ]
  };
};
var getUsWireDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["US_WIRE"],
    fields: [
      {
        label: "Account name",
        value: merchantDetails.usWireDetails.accountName
      }
    ]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  return {
    ...details,
    fields: [
      ...details.fields,
      {
        label: "Account number",
        value: merchantDetails.usWireDetails.accountNumber
      },
      {
        label: "Bank name",
        value: merchantDetails.usWireDetails.bankName
      },
      {
        label: "Bank routing number",
        value: merchantDetails.usWireDetails.bankRoutingNumber
      },
      {
        label: "SWIFT code",
        value: merchantDetails.usWireDetails.swiftCode
      },
      {
        label: "Bank address",
        value: formatAddress4(merchantDetails.usWireDetails.bankAddress).join(
          ", "
        )
      }
    ]
  };
};
var getCaBankAccountDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["CA_BANK_ACCOUNT"],
    fields: [
      {
        label: "Account name",
        value: merchantDetails.legalCompanyName
      }
    ]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  return {
    ...details,
    fields: [
      ...details.fields,
      {
        label: "Account number",
        value: merchantDetails.caBankAccountDetails.accountNumber
      },
      {
        label: "Transit number",
        value: merchantDetails.caBankAccountDetails.transitNumber
      },
      {
        label: "Institution number",
        value: merchantDetails.caBankAccountDetails.institutionNumber
      }
    ]
  };
};
var getCaInternationalDestinationDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["CA_INTERNATIONAL"],
    fields: [
      {
        label: "Legal name",
        value: merchantDetails.canadianInternationalDestination.legalName
      }
    ]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  details.fields = [
    ...details.fields,
    {
      label: "Account number",
      value: merchantDetails.canadianInternationalDestination.accountNumber
    },
    {
      label: "Transit number",
      value: merchantDetails.canadianInternationalDestination.transitNumber
    },
    {
      label: "Bank name",
      value: merchantDetails.canadianInternationalDestination.bankName
    },
    {
      label: "Bank address",
      value: formatAddress4(
        merchantDetails.canadianInternationalDestination.bankAddress
      ).join(", ")
    },
    {
      label: "Institution number",
      value: merchantDetails.canadianInternationalDestination.institutionNumber ?? ""
    },
    {
      label: "SWIFT code",
      value: merchantDetails.canadianInternationalDestination.swiftCode
    }
  ];
  if (merchantDetails.canadianInternationalDestination.intermediaryBank) {
    const intermediaryDetails = [
      {
        label: "Intermediary bank name",
        value: merchantDetails.canadianInternationalDestination.intermediaryBank.bankName
      },
      {
        label: "Intermediary bank address",
        value: formatAddress4(
          merchantDetails.canadianInternationalDestination.intermediaryBank.bankAddress
        ).join(", ")
      },
      {
        label: "Intermediary bank routing number",
        value: merchantDetails.canadianInternationalDestination.intermediaryBank.routingNumber
      },
      {
        label: "Intermediary SWIFT code",
        value: merchantDetails.canadianInternationalDestination.intermediaryBank.swiftCode
      }
    ];
    details.fields = [...details.fields, ...intermediaryDetails];
  }
  return details;
};
var getAustralianDestinationDetails = (merchantDetails) => {
  const details = {
    description: accountDetailsTypeDescription["AUSTRALIAN"],
    fields: [
      {
        label: "Legal name",
        value: merchantDetails.australianDestination.legalName
      }
    ]
  };
  if (merchantDetails.includeBeneficiaryAddressInPaymentDetails) {
    const addressFields = formatAddress4(merchantDetails.address);
    details.fields.push({
      label: "Beneficiary address",
      value: addressFields.join(", ")
    });
  }
  details.fields = [
    ...details.fields,
    {
      label: "Account number",
      value: merchantDetails.australianDestination.accountNumber
    },
    {
      label: "BSB",
      value: merchantDetails.australianDestination.bsb
    },
    {
      label: "SWIFT code",
      value: merchantDetails.australianDestination.swiftCode
    }
  ];
  return details;
};
var isInvoiceMerchantDetailsModel = (obj) => {
  return "usAchDetails" in obj || "usWireDetails" in obj || "caBankAccountDetails" in obj;
};
var isCustomerPortalInvoiceMerchantDetailsModel = (obj) => {
  return "usAchDestination" in obj || "usWireDestination" in obj || "caBankAccountDestination" in obj;
};
var getPaymentAccountDetails = (merchantDetails) => {
  const paymentDetails = [];
  if (merchantDetails.iban) {
    const iban = merchantDetails.iban;
    paymentDetails.push(getIbanPaymentDetails({ ...merchantDetails, iban }));
  }
  if (merchantDetails.ukAccountDetails) {
    const ukAccountDetails = merchantDetails.ukAccountDetails;
    paymentDetails.push(
      getUkAccountDetails({ ...merchantDetails, ukAccountDetails })
    );
  }
  if (merchantDetails.australianDestination) {
    const australianDestination = merchantDetails.australianDestination;
    paymentDetails.push(
      getAustralianDestinationDetails({
        ...merchantDetails,
        australianDestination
      })
    );
  }
  if (merchantDetails.canadianInternationalDestination) {
    const canadianInternationalDestination = merchantDetails.canadianInternationalDestination;
    paymentDetails.push(
      getCaInternationalDestinationDetails({
        ...merchantDetails,
        canadianInternationalDestination
      })
    );
  }
  if (isInvoiceMerchantDetailsModel(merchantDetails) && merchantDetails.usAchDetails) {
    const usAchDetails = merchantDetails.usAchDetails;
    paymentDetails.push(getUsAchDetails({ ...merchantDetails, usAchDetails }));
  }
  if (isCustomerPortalInvoiceMerchantDetailsModel(merchantDetails) && merchantDetails.usAchDestination) {
    const usAchDetails = merchantDetails.usAchDestination;
    paymentDetails.push(getUsAchDetails({ ...merchantDetails, usAchDetails }));
  }
  if (isInvoiceMerchantDetailsModel(merchantDetails) && merchantDetails.usWireDetails) {
    const usWireDetails = merchantDetails.usWireDetails;
    paymentDetails.push(getUsWireDetails({ ...merchantDetails, usWireDetails }));
  }
  if (isCustomerPortalInvoiceMerchantDetailsModel(merchantDetails) && merchantDetails.usWireDestination) {
    const usWireDetails = merchantDetails.usWireDestination;
    paymentDetails.push(getUsWireDetails({ ...merchantDetails, usWireDetails }));
  }
  if (isInvoiceMerchantDetailsModel(merchantDetails) && merchantDetails.caBankAccountDetails) {
    const caBankAccountDetails = merchantDetails.caBankAccountDetails;
    paymentDetails.push(
      getCaBankAccountDetails({ ...merchantDetails, caBankAccountDetails })
    );
  }
  if (isCustomerPortalInvoiceMerchantDetailsModel(merchantDetails) && merchantDetails.caBankAccountDestination) {
    const caBankAccountDetails = merchantDetails.caBankAccountDestination;
    paymentDetails.push(
      getCaBankAccountDetails({ ...merchantDetails, caBankAccountDetails })
    );
  }
  return paymentDetails;
};

// src/components/InvoiceV2/LineItemGroupCard/LineItemGroupCard.tsx
import { Flex as Flex11, Text as Text33 } from "@chakra-ui/react";
import {
  GreyGrey30 as GreyGrey307,
  GreyGrey60 as GreyGrey606,
  GreyWhite,
  Lato13Regular,
  Lato14Bold as Lato14Bold3
} from "@sequencehq/design-tokens";

// src/components/InvoiceV2/LineItemGroupCard/UsageDetailAccordion.tsx
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  Flex as Flex9,
  Text as Text31,
  AccordionPanel
} from "@chakra-ui/react";
import { Lato14Regular as Lato14Regular3, IndigoIndigo50 as IndigoIndigo502 } from "@sequencehq/design-tokens";

// src/components/InvoiceV2/LineItemGroupCard/UsageGraph.tsx
import { Box as Box8, Spinner, Text as Text30 } from "@chakra-ui/react";
import { ParentSize } from "@visx/responsive";
import { BarChart, EmptyChart } from "@sequencehq/core-components";
import { dateTimeWithFormat } from "@sequencehq/formatters";
import {
  GreyGrey60 as GreyGrey602,
  GreyGrey80 as GreyGrey804,
  Lato12Bold as Lato12Bold2,
  Lato12Regular as Lato12Regular2,
  Lato12UppercaseRegular,
  Lato16Bold as Lato16Bold4,
  Spacing24
} from "@sequencehq/design-tokens";
import { Fragment as Fragment13, jsx as jsx53, jsxs as jsxs42 } from "react/jsx-runtime";
var DATE_FORMAT = "dd MMM";
var UsageGraph = ({ data, loading }) => {
  return /* @__PURE__ */ jsxs42(Fragment13, { children: [
    /* @__PURE__ */ jsxs42(Box8, { color: GreyGrey804, ...Lato16Bold4, children: [
      loading && /* @__PURE__ */ jsx53(Spinner, { height: "20px", width: "20px" }),
      !loading ? data?.total : null
    ] }),
    !loading && /* @__PURE__ */ jsxs42(Fragment13, { children: [
      /* @__PURE__ */ jsx53(
        Box8,
        {
          color: GreyGrey602,
          marginBottom: Spacing24,
          ...Lato12UppercaseRegular,
          textTransform: "uppercase",
          children: data?.metricName ?? ""
        }
      ),
      /* @__PURE__ */ jsx53(Box8, { height: "244px", children: /* @__PURE__ */ jsx53(ParentSize, { children: (parent) => data?.total === "0" ? /* @__PURE__ */ jsx53(
        EmptyChart,
        {
          width: parent.width,
          height: parent.height,
          data: data?.usageData ?? [],
          parseDataX: (d) => d.periodStart,
          parseDataY: (d) => Number(d.amount),
          axisBottomTickFormat: (v) => dateTimeWithFormat(v.toString(), DATE_FORMAT),
          style: {
            barGradient: {
              from: "rgba(150, 148, 235, 0.69)",
              to: "#716FFF"
            },
            yAxis: {
              strokeDash: "2"
            }
          }
        }
      ) : /* @__PURE__ */ jsx53(
        BarChart,
        {
          width: parent.width,
          height: parent.height,
          data: data?.usageData ?? [],
          parseDataX: (d) => d.periodStart,
          parseDataY: (d) => Number(d.amount),
          axisBottomTickFormat: (v) => dateTimeWithFormat(v.toString(), DATE_FORMAT),
          tooltip: (d) => {
            return /* @__PURE__ */ jsxs42(Text30, { as: "p", whiteSpace: "nowrap", ...Lato12Regular2, children: [
              /* @__PURE__ */ jsx53(Text30, { as: "span", ...Lato12Bold2, children: d.amount }),
              " \u2013 ",
              dateTimeWithFormat(d.periodStart, DATE_FORMAT)
            ] });
          },
          style: {
            barGradient: {
              from: "rgba(150, 148, 235, 0.69)",
              to: "#716FFF"
            },
            yAxis: {
              strokeDash: "2"
            }
          },
          showColumnGrid: false
        }
      ) }) })
    ] })
  ] });
};

// src/components/InvoiceV2/LineItemGroupCard/SubAccountUsageSummary.tsx
import { Box as Box9, Table as Table2, Tbody, Td, Tr } from "@chakra-ui/react";
import {
  GreyGrey60 as GreyGrey603,
  Lato14Regular as Lato14Regular2,
  GreyGrey10 as GreyGrey102
} from "@sequencehq/design-tokens";
import { jsx as jsx54, jsxs as jsxs43 } from "react/jsx-runtime";
var columnDescription = {
  width: "100%",
  pr: "12px",
  py: "10px",
  ...Lato14Regular2,
  color: GreyGrey603
};
var columnNumeric = {
  width: "1%",
  whiteSpace: "nowrap",
  textAlign: "right",
  px: "12px",
  py: "10px",
  ...Lato14Regular2,
  color: GreyGrey603
};
var SubAccountUsageSummary = (props) => {
  return /* @__PURE__ */ jsx54(
    Box9,
    {
      ...Lato14Regular2,
      width: "100%",
      borderRadius: "8px",
      backgroundColor: GreyGrey102,
      padding: "8px 16px",
      children: /* @__PURE__ */ jsx54(Table2, { variant: "lineItemGroup", width: "100%", children: /* @__PURE__ */ jsx54(Tbody, { children: props.usageBreakdown.map((item) => {
        return /* @__PURE__ */ jsxs43(Tr, { children: [
          /* @__PURE__ */ jsx54(Td, { ...columnDescription, children: item.description }),
          /* @__PURE__ */ jsx54(Td, { ...columnNumeric, children: item.quantity })
        ] }, `${item.description}${item.quantity}`);
      }) }) })
    }
  );
};

// src/components/InvoiceV2/LineItemGroupCard/UsageDetailAccordion.tsx
import { Fragment as Fragment14, jsx as jsx55, jsxs as jsxs44 } from "react/jsx-runtime";
var UsageDetailAccordion = ({
  usageData,
  subAccountBreakdown
}) => /* @__PURE__ */ jsx55(Accordion, { allowToggle: true, width: "100%", children: /* @__PURE__ */ jsx55(AccordionItem, { border: "none", children: ({ isExpanded }) => /* @__PURE__ */ jsxs44(Fragment14, { children: [
  /* @__PURE__ */ jsx55(AccordionButton, { _hover: { bg: "none" }, px: "0", py: "0", children: /* @__PURE__ */ jsxs44(Flex9, { align: "center", gap: "4px", children: [
    /* @__PURE__ */ jsxs44(Text31, { ...Lato14Regular3, color: IndigoIndigo502, children: [
      isExpanded ? "Hide" : "Show",
      " usage details"
    ] }),
    isExpanded ? /* @__PURE__ */ jsx55(ChevronUpIcon, { boxSize: "20px", color: IndigoIndigo502 }) : /* @__PURE__ */ jsx55(ChevronDownIcon, { boxSize: "20px", color: IndigoIndigo502 })
  ] }) }),
  /* @__PURE__ */ jsx55(AccordionPanel, { padding: "0", children: /* @__PURE__ */ jsxs44(Flex9, { direction: "column", gap: "12px", pt: "8px", children: [
    /* @__PURE__ */ jsx55(UsageGraph, { data: usageData, loading: !usageData }),
    subAccountBreakdown && Boolean(subAccountBreakdown?.length) && /* @__PURE__ */ jsx55(SubAccountUsageSummary, { usageBreakdown: subAccountBreakdown })
  ] }) })
] }) }) });

// src/components/InvoiceV2/LineItemGroupCard/LineItemGroupCardTable/LineItemGroupCardTable.tsx
import { Table as Table3 } from "@chakra-ui/react";

// src/components/InvoiceV2/LineItemGroupCard/LineItemGroupCardTable/Body.tsx
import { Tbody as Tbody2, Tr as Tr2, Td as Td2, Text as Text32, Flex as Flex10 } from "@chakra-ui/react";
import {
  GreyGrey100 as GreyGrey1002,
  Lato14Regular as Lato14Regular4,
  Lato14Bold as Lato14Bold2,
  GreyGrey60 as GreyGrey604,
  GreyGrey50 as GreyGrey502,
  GreyGrey90,
  GreyGrey30 as GreyGrey306
} from "@sequencehq/design-tokens";
import { Tooltip } from "@sequencehq/core-components";
import { InformationCircleIcon } from "@heroicons/react/16/solid";
import { jsx as jsx56, jsxs as jsxs45 } from "react/jsx-runtime";
var Body = ({ group, lineItemEditControls }) => {
  const columnDescription3 = {
    width: "100%",
    pr: "12px",
    py: "10px"
  };
  const columnNumeric3 = {
    width: "120px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textAlign: "right",
    px: "12px",
    py: "10px",
    ...Lato14Regular4,
    color: GreyGrey604
  };
  const showTaxCategory = !!group.taxCategory?.id;
  return /* @__PURE__ */ jsxs45(Tbody2, { children: [
    group.lineItems.map((item, i) => /* @__PURE__ */ jsxs45(Tr2, { children: [
      /* @__PURE__ */ jsx56(Td2, { ...columnDescription3, title: item.description, children: /* @__PURE__ */ jsxs45(Text32, { ...Lato14Regular4, children: [
        /* @__PURE__ */ jsx56(Text32, { as: "span", color: GreyGrey90, children: item.title }),
        item.description && /* @__PURE__ */ jsx56(Text32, { as: "span", color: GreyGrey604, marginLeft: "8px", children: item.description })
      ] }) }),
      /* @__PURE__ */ jsx56(Td2, { ...columnNumeric3, title: item.quantity, children: item.quantity }),
      /* @__PURE__ */ jsx56(Td2, { ...columnNumeric3, title: item.rate, children: item.rate }),
      /* @__PURE__ */ jsx56(
        Td2,
        {
          ...columnNumeric3,
          color: GreyGrey1002,
          paddingRight: lineItemEditControls ? void 0 : 0,
          title: item.price,
          children: item.price
        }
      ),
      lineItemEditControls && /* @__PURE__ */ jsx56(Td2, { width: "32px", children: lineItemEditControls(i, item.id) })
    ] }, item.id)),
    /* @__PURE__ */ jsxs45(Tr2, { borderTop: `1px solid ${GreyGrey306}`, children: [
      /* @__PURE__ */ jsx56(Td2, { colSpan: 2 }),
      /* @__PURE__ */ jsx56(
        Td2,
        {
          ...Lato14Regular4,
          color: GreyGrey604,
          pr: "12px",
          py: "10px",
          pb: "0px",
          textAlign: "right",
          children: "Subtotal"
        }
      ),
      /* @__PURE__ */ jsx56(
        Td2,
        {
          ...Lato14Regular4,
          color: GreyGrey604,
          paddingLeft: "12px",
          paddingRight: lineItemEditControls ? "12px" : 0,
          py: "10px",
          pb: "0px",
          textAlign: "right",
          children: group.total
        }
      ),
      lineItemEditControls && /* @__PURE__ */ jsx56(Td2, {})
    ] }),
    /* @__PURE__ */ jsxs45(Tr2, { children: [
      /* @__PURE__ */ jsx56(Td2, { colSpan: 2 }),
      /* @__PURE__ */ jsx56(
        Td2,
        {
          ...Lato14Regular4,
          color: GreyGrey604,
          pr: "12px",
          py: "16px",
          pb: "0px",
          textAlign: "right",
          children: /* @__PURE__ */ jsxs45(Flex10, { alignItems: "center", justifyContent: "flex-end", gap: 1, children: [
            "Tax",
            showTaxCategory ? /* @__PURE__ */ jsx56(Tooltip, { label: `Tax category: ${group.taxCategory?.name}`, children: /* @__PURE__ */ jsx56(
              InformationCircleIcon,
              {
                "data-testid": `lineItemGroup-${group.id}.taxCategoryTooltip`,
                color: GreyGrey502,
                height: 16,
                width: 16
              }
            ) }) : null
          ] })
        }
      ),
      /* @__PURE__ */ jsx56(
        Td2,
        {
          ...Lato14Regular4,
          color: GreyGrey604,
          paddingLeft: "12px",
          paddingRight: lineItemEditControls ? "12px" : 0,
          py: "16px",
          pb: "0px",
          textAlign: "right",
          children: group.totalTax
        }
      ),
      lineItemEditControls && /* @__PURE__ */ jsx56(Td2, {})
    ] }),
    /* @__PURE__ */ jsxs45(Tr2, { children: [
      /* @__PURE__ */ jsx56(Td2, { colSpan: 2 }),
      /* @__PURE__ */ jsx56(Td2, { ...Lato14Regular4, pr: "12px", py: "16px", pb: "0px", textAlign: "right", children: "Total" }),
      /* @__PURE__ */ jsx56(
        Td2,
        {
          ...Lato14Bold2,
          paddingLeft: "12px",
          paddingRight: lineItemEditControls ? "12px" : 0,
          py: "16px",
          pb: "0px",
          textAlign: "right",
          children: group.grossTotal
        }
      ),
      lineItemEditControls && /* @__PURE__ */ jsx56(Td2, {})
    ] })
  ] });
};

// src/components/InvoiceV2/LineItemGroupCard/LineItemGroupCardTable/Header.tsx
import { Thead, Tr as Tr3, Th } from "@chakra-ui/react";
import { Lato12UppercaseBold, GreyGrey60 as GreyGrey605 } from "@sequencehq/design-tokens";
import { jsx as jsx57, jsxs as jsxs46 } from "react/jsx-runtime";
var Header2 = ({ hasLineItemEditControls }) => {
  const headerDescription2 = {
    ...Lato12UppercaseBold,
    color: GreyGrey605,
    width: "100%",
    pr: "12px",
    py: "10px"
  };
  const headerNumeric2 = {
    ...Lato12UppercaseBold,
    color: GreyGrey605,
    width: "120px",
    whiteSpace: "nowrap",
    textAlign: "right",
    px: "12px",
    py: "10px"
  };
  return /* @__PURE__ */ jsx57(Thead, { children: /* @__PURE__ */ jsxs46(Tr3, { children: [
    /* @__PURE__ */ jsx57(Th, { ...headerDescription2, children: "Description" }),
    /* @__PURE__ */ jsx57(Th, { ...headerNumeric2, children: "Qty" }),
    /* @__PURE__ */ jsx57(Th, { ...headerNumeric2, children: "Rate" }),
    /* @__PURE__ */ jsx57(
      Th,
      {
        ...headerNumeric2,
        paddingRight: hasLineItemEditControls ? void 0 : 0,
        children: "Price"
      }
    ),
    hasLineItemEditControls && /* @__PURE__ */ jsx57(Th, { width: "32px" })
  ] }) });
};

// src/components/InvoiceV2/LineItemGroupCard/LineItemGroupCardTable/LineItemGroupCardTable.tsx
import { jsx as jsx58, jsxs as jsxs47 } from "react/jsx-runtime";
var LineItemGroupCardTable = ({
  group,
  lineItemEditControls
}) => {
  return /* @__PURE__ */ jsxs47(Table3, { variant: "lineItemGroup", children: [
    /* @__PURE__ */ jsx58(Header2, { hasLineItemEditControls: Boolean(lineItemEditControls) }),
    /* @__PURE__ */ jsx58(Body, { group, lineItemEditControls })
  ] });
};

// src/components/InvoiceV2/LineItemGroupCard/LineItemGroupCard.tsx
import { jsx as jsx59, jsxs as jsxs48 } from "react/jsx-runtime";
var LineItemGroupCard = ({
  "data-testid": testId,
  group,
  groupHeader,
  lineItemGroupEditControls,
  lineItemEditControls,
  isDisabled = false,
  emptyState
}) => {
  const groupClassName = `sq-line-items-${group.id.replace(/:/g, "-")}`;
  const defaultGroupHeader = /* @__PURE__ */ jsxs48(
    Flex11,
    {
      minHeight: "36px",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      children: [
        /* @__PURE__ */ jsxs48(Flex11, { gap: "8px", children: [
          /* @__PURE__ */ jsx59(Text33, { ...Lato14Bold3, children: group.description }),
          /* @__PURE__ */ jsx59(Text33, { ...Lato13Regular, color: GreyGrey606, children: group.servicePeriodLabel })
        ] }),
        lineItemGroupEditControls && lineItemGroupEditControls(groupClassName)
      ]
    }
  );
  const hasLineItemGroups = group.lineItems && group.lineItems.length > 0;
  return /* @__PURE__ */ jsxs48(
    Flex11,
    {
      "data-testid": testId,
      padding: hasLineItemGroups ? "16px 24px 24px 24px" : "16px 24px",
      className: `${groupClassName}`,
      style: isDisabled ? { opacity: 0.3, pointerEvents: "none" } : {},
      background: GreyWhite,
      boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 4px 0px rgba(0, 0, 0, 0.02)",
      borderRadius: "8px",
      border: `${GreyGrey307} 1px solid`,
      flexDirection: "column",
      children: [
        groupHeader ? groupHeader : defaultGroupHeader,
        group.lineItems && group.lineItems.length > 0 ? /* @__PURE__ */ jsx59(
          LineItemGroupCardTable,
          {
            group,
            lineItemEditControls
          }
        ) : emptyState,
        Boolean(
          group.containsUsage || group.usageData || group.subAccountUsageBreakdown?.length
        ) && /* @__PURE__ */ jsx59(Flex11, { mt: "8px", children: /* @__PURE__ */ jsx59(
          UsageDetailAccordion,
          {
            usageData: group.usageData,
            subAccountBreakdown: group.subAccountUsageBreakdown
          }
        ) })
      ]
    },
    group.id
  );
};

// src/components/InvoiceV2/SubAccountUsageBreakdownCard/SubAccountUsageBreakdownCard.tsx
import { Flex as Flex12, Table as Table4, Tbody as Tbody3, Td as Td3, Thead as Thead2, Tr as Tr4 } from "@chakra-ui/react";
import {
  GreyGrey30 as GreyGrey308,
  GreyGrey60 as GreyGrey607,
  GreyWhite as GreyWhite2,
  Lato14Regular as Lato14Regular5,
  Lato12UppercaseBold as Lato12UppercaseBold2,
  Lato14Bold as Lato14Bold4
} from "@sequencehq/design-tokens";
import { jsx as jsx60, jsxs as jsxs49 } from "react/jsx-runtime";
var headerDescription = {
  ...Lato12UppercaseBold2,
  color: GreyGrey607,
  pr: "24px",
  py: "10px",
  textTransform: "uppercase",
  width: "fit-content"
};
var headerNumeric = {
  ...Lato12UppercaseBold2,
  color: GreyGrey607,
  width: "fit-content",
  whiteSpace: "nowrap",
  textAlign: "right",
  px: "12px",
  py: "10px",
  textTransform: "uppercase"
};
var columnDescription2 = {
  pr: "48px",
  py: "10px",
  ...Lato14Regular5,
  color: GreyGrey607,
  width: "fit-content"
};
var columnNumeric2 = {
  width: "fit-content",
  whiteSpace: "nowrap",
  textAlign: "right",
  px: "12px",
  py: "10px",
  ...Lato14Regular5,
  color: GreyGrey607
};
var SubAccountUsageBreakdownCard = (props) => {
  if (!props.usageBreakdown.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs49(
    Flex12,
    {
      padding: "16px 24px 24px",
      background: GreyWhite2,
      boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 4px 0px rgba(0, 0, 0, 0.02)",
      borderRadius: "8px",
      border: `${GreyGrey308} 1px solid`,
      flexDirection: "column",
      children: [
        /* @__PURE__ */ jsx60(
          Flex12,
          {
            ...Lato14Bold4,
            minHeight: "36px",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            children: "Usage overview"
          }
        ),
        /* @__PURE__ */ jsxs49(Table4, { variant: "lineItemGroup", width: "100%", children: [
          /* @__PURE__ */ jsx60(Thead2, { children: /* @__PURE__ */ jsxs49(Tr4, { children: [
            /* @__PURE__ */ jsx60(Td3, { ...headerDescription, children: "Sub account" }),
            /* @__PURE__ */ jsx60(Td3, { ...headerDescription, children: "Metric" }),
            /* @__PURE__ */ jsx60(Td3, { ...headerNumeric, children: "qty" })
          ] }) }),
          /* @__PURE__ */ jsx60(Tbody3, { children: props.usageBreakdown.map((item) => {
            return item.usageData.map((usageData, idx) => {
              return /* @__PURE__ */ jsxs49(Tr4, { children: [
                /* @__PURE__ */ jsx60(Td3, { ...columnDescription2, children: !idx && item.subAccountLabel }),
                /* @__PURE__ */ jsx60(Td3, { ...columnDescription2, children: usageData.label }),
                /* @__PURE__ */ jsx60(Td3, { ...columnNumeric2, children: usageData.quantity })
              ] }, `${item.subAccountLabel}${usageData.label}`);
            });
          }) })
        ] })
      ]
    }
  );
};
export {
  CanadianInternationalPaymentDetails,
  CanadianPaymentDetails,
  CreditNoteDownloadButton,
  GroupSummary,
  IbanPaymentDetails,
  InvoiceDownloadButton,
  LineItemGroupCard,
  PaymentDetailsDrawer,
  ReactPdfCreditNote,
  ReactPdfInvoice,
  SubAccountUsageBreakdownCard,
  UkPaymentDetails,
  UsAchPaymentDetails,
  UsWirePaymentDetails,
  getPaymentAccountDetails
};
//# sourceMappingURL=index.js.map